/* (6) toki-wheel.part4.js — spin engine + flick + countdown + winner modal + confetti + multi-pick */
(function(){
  'use strict';

  var TW = window.TokiWheel, U = TW && TW.util, R = TW && TW.refs;
  if(!TW || !U || !R) return;

  TW.ensureState();

  // ---------- Cloudflare spin counter hook (SURGICAL ADD) ----------
  // This posts 1 spin to your Worker and broadcasts an event for any separate ticker section.
  var COUNTER_BASE = "https://wheel-spin-counter.johnniedropmx.workers.dev";

  function postSpinToCounter(meta){
    meta = meta || {};

    // Broadcast a local, per-wheel completion event before the optional
    // Cloudflare counter request. Archive galleries use this event to award
    // progress immediately, even if the network counter is unavailable.
    try{
      var activePreset = window.TOKI_WHEEL_PRESET || {};
      var wheelId = String(
        activePreset.archiveId ||
        activePreset.id ||
        window.location.pathname ||
        'unknown-wheel'
      ).toLowerCase().trim();

      window.dispatchEvent(new CustomEvent('toki:wheel-spin-complete', {
        detail: {
          wheelId: wheelId,
          winnerLabel: meta.winnerLabel || '',
          completedAt: Date.now()
        }
      }));
    }catch(_){}

    try{
      fetch(COUNTER_BASE + "/spin", {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          source: meta.source || "spinthewheellab",
          winnerLabel: meta.winnerLabel || "",
          ts: Date.now()
        })
      })
      .then(function(r){ return r.json(); })
      .then(function(data){
        try{
          window.dispatchEvent(new CustomEvent("tw:spinCounter", { detail: data }));
        }catch(_){}
      })
      .catch(function(){});
    }catch(_){}
  }
  // ---------- end Cloudflare hook ----------

  // =========================================================
  // ✅ SURGICAL ADD: Ensure center badge is actually rendered
  // =========================================================
  function ensureWheelSvgRefs(){
    try{
      if(!R.wheelSvg){
        if(R.wheelGroup && R.wheelGroup.ownerSVGElement){
          R.wheelSvg = R.wheelGroup.ownerSVGElement;
        }else{
          var root = document.getElementById('toki-wheel-root');
          if(root){
            var svg = root.querySelector('svg');
            if(svg) R.wheelSvg = svg;
          }
        }
      }
      if(!R.wheelSvg) return false;
      return true;
    }catch(_){
      return false;
    }
  }

  function ensureCenterBadge(){
    if(!ensureWheelSvgRefs()) return;

    var svg = R.wheelSvg;

    // ✅ IMPORTANT: The core renderer (part3) already draws the center badge inside #twWheelGroup.
    // Our earlier "center badge layer" patch can create a *second* badge that does NOT rotate with the wheel,
    // which shows up as a "double Vortex" during spins (especially after segment image edits).
    // So: if the base center image exists, we remove any extra layer and just point refs at the base.
    try{
      var baseImg = svg.querySelector('#twWheelGroup image.tw-centerAlwaysSpin') || svg.querySelector('#twWheelGroup .tw-centerAlwaysSpin');
      if(baseImg){
        // remove any injected layer(s)
        try{
          var root = document.getElementById('toki-wheel-root');
          if(root && root.querySelectorAll){
            var layers0 = root.querySelectorAll('#twCenterBadgeLayer');
            for(var k=0;k<layers0.length;k++){
              var l0 = layers0[k];
              if(l0 && l0.parentNode) { try{ l0.parentNode.removeChild(l0); }catch(_){ } }
            }
          }
        }catch(_){}
        try{
          var layInSvg = svg.querySelector('#twCenterBadgeLayer');
          if(layInSvg && layInSvg.parentNode) layInSvg.parentNode.removeChild(layInSvg);
        }catch(_){}
        R.centerImg = baseImg;
        return;
      }
    }catch(_){}


    // ✅ DEDUPE SAFETY: if multiple SVGs exist under the root (can happen
    // during segment image picker re-renders on some mobile browsers), ensure
    // only the ACTIVE wheel SVG keeps the center badge layer.
    try{
      var root = document.getElementById('toki-wheel-root');
      if(root && root.querySelectorAll){
        var layers = root.querySelectorAll('#twCenterBadgeLayer');
        for(var i=0;i<layers.length;i++){
          var lay = layers[i];
          if(!lay) continue;
          // keep only if this layer belongs to the active wheel SVG
          if(lay.ownerSVGElement !== svg && lay.parentNode){
            try{ lay.parentNode.removeChild(lay); }catch(_){ }
          }
        }
      }
    }catch(_){ }

    var ui = (TW.state && TW.state.ui) ? TW.state.ui : {};
    var url = (ui.centerBadgeUrl != null) ? String(ui.centerBadgeUrl || '').trim() : '';
    var mask = (ui.centerBadgeMask != null) ? String(ui.centerBadgeMask || '').trim().toLowerCase() : '';

    if(!url){
      try{
        var oldLayer = svg.querySelector('#twCenterBadgeLayer');
        if(oldLayer && oldLayer.parentNode) oldLayer.parentNode.removeChild(oldLayer);
      }catch(_){}
      R.centerImg = null;
      return;
    }

    var defs = null;
    try{
      defs = svg.querySelector('defs');
      if(!defs){
        defs = document.createElementNS('http://www.w3.org/2000/svg','defs');
        svg.insertBefore(defs, svg.firstChild);
      }
    }catch(_){}

    var layer = null;
    try{
      layer = svg.querySelector('#twCenterBadgeLayer');
      if(!layer){
        layer = document.createElementNS('http://www.w3.org/2000/svg','g');
        layer.setAttribute('id','twCenterBadgeLayer');
        svg.appendChild(layer);
      }
    }catch(_){}

    if(!layer) return;

    var img = null;
    try{
      img = layer.querySelector('image');
      if(!img){
        img = document.createElementNS('http://www.w3.org/2000/svg','image');
        img.setAttribute('id','twCenterBadgeImg');
        img.setAttribute('preserveAspectRatio','xMidYMid slice');
        layer.appendChild(img);
      }
    }catch(_){}

    if(!img) return;

    var base = 260;
    var sc = parseFloat(ui.centerBadgeScale);
    if(!(sc > 0)) sc = 1;

    var offX = parseFloat(ui.centerBadgeOffX || 0); if(!isFinite(offX)) offX = 0;
    var offY = parseFloat(ui.centerBadgeOffY || 0); if(!isFinite(offY)) offY = 0;

    var size = base * sc;
    size = U.clamp(size, 120, 520);

    var x = 500 - (size/2) + offX;
    var y = 500 - (size/2) + offY;

    img.setAttribute('x', String(x));
    img.setAttribute('y', String(y));
    img.setAttribute('width', String(size));
    img.setAttribute('height', String(size));

    try{ img.setAttributeNS('http://www.w3.org/1999/xlink','href', url); }catch(_){}
    try{ img.setAttribute('href', url); }catch(_){}

    if(defs && mask === 'circle'){
      var clipId = 'twCenterBadgeClip';
      var clip = null;
      try{
        clip = defs.querySelector('#' + clipId);
        if(!clip){
          clip = document.createElementNS('http://www.w3.org/2000/svg','clipPath');
          clip.setAttribute('id', clipId);
          defs.appendChild(clip);
        }

        while(clip.firstChild) clip.removeChild(clip.firstChild);

        var c = document.createElementNS('http://www.w3.org/2000/svg','circle');
        c.setAttribute('cx', String(500 + offX));
        c.setAttribute('cy', String(500 + offY));
        c.setAttribute('r', String(size/2));
        clip.appendChild(c);

        img.setAttribute('clip-path', 'url(#' + clipId + ')');
      }catch(_){}
    }else{
      try{ img.removeAttribute('clip-path'); }catch(_){}
    }

    R.centerImg = img;

    try{
      var editOn = (ui.centerBadgeEditOn || 'no') === 'yes';
      img.style.cursor = editOn ? 'grab' : '';
      img.style.pointerEvents = 'auto';
    }catch(_){}
  }

  (function patchRenderWheelForBadge(){
    if(TW._centerBadgePatched) return;
    TW._centerBadgePatched = true;

    var orig = TW.renderWheel;
    if(typeof orig === 'function'){
      TW.renderWheel = function(){
        var r = orig.apply(this, arguments);
        try{ ensureCenterBadge(); }catch(_){}
        return r;
      };
    }
  })();
  // =========================================================
  // ✅ END center badge surgical add
  // =========================================================

  // =========================================================
  // ✅ SURGICAL ADD: AUDIO UNLOCK BRIDGE (Fixes iOS countdown muting)
  // =========================================================
  TW.audioBridge = TW.audioBridge || (function(){
    var armed = false;
    var ctx = null;

    function getSpinUrl(){
      try{
        var s = (TW.CONST && TW.CONST.MAIN_SPIN_SOUND) ? TW.CONST.MAIN_SPIN_SOUND : null;
        return (s && s.url) ? s.url : '';
      }catch(_){ return ''; }
    }

    function getWinUrl(){
      try{
        var id = (TW.state && TW.state.ui && TW.state.ui.winSoundId) ? TW.state.ui.winSoundId : 'air_zing';
        var s = (TW.CONST && TW.CONST.CELEBRATION_SOUNDS) ? (TW.CONST.CELEBRATION_SOUNDS.find(function(x){ return x.id === id; }) || TW.CONST.CELEBRATION_SOUNDS[0]) : null;
        return s && s.url ? s.url : '';
      }catch(_){ return ''; }
    }

    function arm(){
      if(armed && (!ctx || ctx.state === 'running')) return true;

      // Mark success only after this document's context is actually running.
      // A blocked early attempt stays retryable on the pointerdown that starts a flick.
      try{
        var AC = window.AudioContext || window.webkitAudioContext;
        if(AC){
          ctx = ctx || new AC();
          var resumed = ctx.resume ? ctx.resume() : null;
          if(resumed && resumed.then){
            resumed.then(function(){ armed = (ctx.state === 'running'); }).catch(function(){ armed = false; });
          }else{
            armed = (ctx.state === 'running');
          }
          var o = ctx.createOscillator();
          var g = ctx.createGain();
          g.gain.value = 0; // silent unlock
          o.connect(g); g.connect(ctx.destination);
          o.start();
          o.stop(ctx.currentTime + 0.02);
          return armed;
        }
      }catch(_){ armed = false; }
      return false;
    }

    return { arm: arm };
  })();
  // =========================================================
  // ✅ END AUDIO UNLOCK BRIDGE
  // =========================================================

  // =========================================================
  // ✅ SURGICAL ADD: VOICE UNLOCK BRIDGE (Fixes iOS needing "Test Voice" first)
  // =========================================================
  TW.voiceBridge = TW.voiceBridge || (function(){
    var armed = false;

    function isIOS(){
      try{
        return /iPad|iPhone|iPod/.test(navigator.userAgent || '') ||
               (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      }catch(_){ return false; }
    }

    function arm(){
      if(armed) return;
      armed = true;

      // iOS Safari often requires a speech call INSIDE a user gesture at least once.
      try{
        if(!window.speechSynthesis) return;

        // Kick voices list (some iOS builds require a getVoices call first)
        try{ window.speechSynthesis.getVoices(); }catch(_){}

        // Silent/near-silent priming utterance
        var u = new SpeechSynthesisUtterance(' ');
        u.volume = 0;     // silent
        u.rate = 1;
        u.pitch = 1;

        // If iOS: keep it extremely short and cancel quickly
        window.speechSynthesis.speak(u);

        // Cancel after a tiny delay to avoid "stuck speaking" bugs
        setTimeout(function(){
          try{ window.speechSynthesis.cancel(); }catch(_){}
        }, isIOS() ? 120 : 60);
      }catch(_){}
    }

    return { arm: arm };
  })();

  // Also arm voice on the first real gesture inside the wheel root
  function bindFirstGestureVoiceArm(){
    if(TW._firstGestureVoiceBound) return;
    TW._firstGestureVoiceBound = true;

    try{
      var root = document.getElementById('toki-wheel-root');
      if(!root) return;

      var once = function(){
        try{ TW.voiceBridge && TW.voiceBridge.arm && TW.voiceBridge.arm(); }catch(_){}
        try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
        root.removeEventListener('pointerdown', once, true);
        root.removeEventListener('touchstart', once, true);
        root.removeEventListener('mousedown', once, true);
      };

      // capture=true makes it reliable even if other handlers stopPropagation
      root.addEventListener('pointerdown', once, true);
      root.addEventListener('touchstart', once, { passive:true, capture:true });
      root.addEventListener('mousedown', once, true);
    }catch(_){}
  }
  // =========================================================
  // ✅ END VOICE UNLOCK BRIDGE
  // =========================================================

  // =========================================================
  // 🎛️ FIDGET MODE (CENTER BADGE LONG-PRESS) — FIDGET ONLY
  // (unchanged from your version)
  // =========================================================
  TW._fidget = TW._fidget || {
    on: false,
    deg: 0,
    vel: 0,
    raf: 0,
    lastT: 0,
    dragging: false,
    holdT: 0,
    holdRAF: 0,
    holdArmed: false,
    downPt: null,
    lastAng: 0,
    lastMoveT: 0,
    lastTickNotch: 0,
    turboCooldownT: 0
  };

  function fidgetCfg(){
    var ui = TW.state.ui || (TW.state.ui = {});
    var speed = (ui.fidgetSpeed || 'normal'); // slow|normal|wild
    var fr = (speed === 'slow') ? 0.965 : (speed === 'wild' ? 0.988 : 0.978);
    var maxV = (speed === 'slow') ? 0.020 : (speed === 'wild' ? 0.090 : 0.055);
    return {
      speed: speed,
      friction: fr,
      maxVel: maxV,
      tick: (ui.fidgetTickOn || 'no') === 'yes',
      haptics: (ui.fidgetHapticsOn || 'no') === 'yes',
      snap: (ui.fidgetSnapOn || 'no') === 'yes'
    };
  }

  function hasHaptics(){ return !!(navigator && navigator.vibrate); }
  function vibe(ms){ try{ if(hasHaptics()) navigator.vibrate(ms|0); }catch(_){ } }

  var _tickAC = null;
  var _lastTickSoundT = 0;
  function tickSound(){
    try{
      // APPLE SURGICAL 2026-04-28C:
      // Keep tick suppressed during real spin/startup audio, BUT allow it when the
      // user is intentionally inside Fidget Mode and has selected Tick.
      try{
        var fidgetActive = !!(TW && TW._fidget && TW._fidget.on);
        if(!fidgetActive && TW && TW._rt && (TW._rt.spinning || TW._rt.preSpinTO || TW._rt.lockTeaseBusy)) return;
        if(TW && typeof TW.isSoundEnabled === 'function' && !TW.isSoundEnabled()) return;
      }catch(_){ }
      var now = performance.now();
      var minGap = isIOS() ? 95 : 28;
      if(now - _lastTickSoundT < minGap) return;
      _lastTickSoundT = now;

      var AC = window.AudioContext || window.webkitAudioContext;
      if(!AC) return;
      if(!_tickAC) _tickAC = new AC();
      if(_tickAC.state === 'suspended') _tickAC.resume().catch(function(){});

      var o = _tickAC.createOscillator();
      var g = _tickAC.createGain();
      o.type = 'square';
      o.frequency.value = 260 + Math.random()*90;

      g.gain.value = 0.0001;
      o.connect(g);
      g.connect(_tickAC.destination);

      var t0 = _tickAC.currentTime;
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(isIOS() ? 0.028 : 0.10, t0 + 0.005);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.030);

      o.start(t0);
      o.stop(t0 + 0.032);
    }catch(_){}
  }

  function ensureFidgetEls(){
    if(!R.wheelWrap) return false;

    if(!R.wheelWrap.__twRel){
      R.wheelWrap.__twRel = true;
      try{
        var cs = window.getComputedStyle(R.wheelWrap);
        if(cs && cs.position === 'static') R.wheelWrap.style.position = 'relative';
      }catch(_){
        R.wheelWrap.style.position = 'relative';
      }
    }

    if(!R.fidgetGlass){
      var g = document.createElement('div');
      g.className = 'tw-fidgetGlass';
      g.hidden = true;
      R.wheelWrap.appendChild(g);
      R.fidgetGlass = g;
    }

    if(!R.fidgetBadge){
      var b = document.createElement('div');
      b.className = 'tw-fidgetBadge';
      b.textContent = 'FIDGET MODE';
      b.hidden = true;
      R.wheelWrap.appendChild(b);
      R.fidgetBadge = b;
    }

    if(!R.fidgetCharge){
      var c = document.createElement('div');
      c.className = 'tw-fidgetCharge';
      c.hidden = true;
      R.wheelWrap.appendChild(c);
      R.fidgetCharge = c;
    }

    if(!R.fidgetBurst){
      var s = document.createElement('div');
      s.className = 'tw-fidgetBurst';
      s.hidden = true;
      R.wheelWrap.appendChild(s);
      R.fidgetBurst = s;
    }

    if(!R.fidgetX){
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'tw-fidgetX';
      x.textContent = '×';
      x.hidden = true;
      x.addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        TW.exitFidgetMode && TW.exitFidgetMode('x');
      });
      R.wheelWrap.appendChild(x);
      R.fidgetX = x;
    }

    if(!R.fidgetPanel){
      var p = document.createElement('div');
      p.className = 'tw-fidgetPanel';
      p.hidden = true;

      var speed = document.createElement('div');
      speed.className = 'tw-fidgetRow';

      function mkBtn(txt, val){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tw-fidgetBtn';
        btn.textContent = txt;
        btn.setAttribute('data-val', val);
        btn.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          TW.pushUndo && TW.pushUndo();
          TW.state.ui = TW.state.ui || {};
          TW.state.ui.fidgetSpeed = val;
          setFidgetSpeedUI();
          TW.saveSoon && TW.saveSoon();
        });
        return btn;
      }

      var speedLab = document.createElement('div');
      speedLab.className = 'tw-fidgetLab';
      speedLab.textContent = 'Speed';

      var speedBtns = document.createElement('div');
      speedBtns.className = 'tw-fidgetGroup';
      speedBtns.appendChild(mkBtn('Slow','slow'));
      speedBtns.appendChild(mkBtn('Normal','normal'));
      speedBtns.appendChild(mkBtn('Wild','wild'));

      speed.appendChild(speedLab);
      speed.appendChild(speedBtns);

      var toggles = document.createElement('div');
      toggles.className = 'tw-fidgetRow';

      function mkToggle(txt, key, onlyIf){
        var wrap = document.createElement('div');
        wrap.className = 'tw-fidgetToggle';

        var lab = document.createElement('span');
        lab.className = 'tw-fidgetLab';
        lab.textContent = txt;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tw-fidgetBtn';
        btn.textContent = 'Off';
        btn.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if(onlyIf && !onlyIf()) return;
          TW.pushUndo && TW.pushUndo();
          TW.state.ui = TW.state.ui || {};
          var cur = (TW.state.ui[key] || 'no') === 'yes';
          TW.state.ui[key] = cur ? 'no' : 'yes';
          setFidgetToggleUI();
          TW.saveSoon && TW.saveSoon();
          if(key === 'fidgetHapticsOn' && (TW.state.ui[key] === 'yes')) vibe(12);
        });

        wrap.appendChild(lab);
        wrap.appendChild(btn);
        wrap.__btn = btn;
        wrap.__key = key;
        return wrap;
      }

      var tTick = mkToggle('Tick', 'fidgetTickOn');
      var tHap  = mkToggle('Haptics', 'fidgetHapticsOn', function(){ return hasHaptics(); });
      var tSnap = mkToggle('Snap', 'fidgetSnapOn');

      toggles.appendChild(tTick);
      toggles.appendChild(tHap);
      toggles.appendChild(tSnap);

      var stopRow = document.createElement('div');
      stopRow.className = 'tw-fidgetRow';

      var stopBtn = document.createElement('button');
      stopBtn.type = 'button';
      stopBtn.className = 'tw-fidgetBtn tw-fidgetStop';
      stopBtn.textContent = 'Stop / Re-center';
      stopBtn.addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        stopFidgetMotion(true);
      });

      stopRow.appendChild(stopBtn);

      p.appendChild(speed);
      p.appendChild(toggles);
      p.appendChild(stopRow);

      R.fidgetPanel = p;
      R.wheelWrap.appendChild(p);

      function setFidgetSpeedUI(){
        var ui = TW.state.ui || {};
        var val = ui.fidgetSpeed || 'normal';
        var btns = p.querySelectorAll('.tw-fidgetGroup .tw-fidgetBtn');
        for(var i=0;i<btns.length;i++){
          var b = btns[i];
          if(!b) continue;
          var v = b.getAttribute('data-val') || '';
          if(v === val) b.classList.add('isOn');
          else b.classList.remove('isOn');
        }
      }

      function setFidgetToggleUI(){
        var ui = TW.state.ui || {};
        var list = p.querySelectorAll('.tw-fidgetToggle');
        for(var i=0;i<list.length;i++){
          var w = list[i];
          var btn = w && w.__btn;
          var key = w && w.__key;
          if(!btn || !key) continue;

          if(key === 'fidgetHapticsOn' && !hasHaptics()){
            btn.textContent = 'N/A';
            btn.disabled = true;
            btn.classList.remove('isOn');
            continue;
          }else{
            btn.disabled = false;
          }

          var on = (ui[key] || 'no') === 'yes';
          btn.textContent = on ? 'On' : 'Off';
          if(on) btn.classList.add('isOn'); else btn.classList.remove('isOn');
        }
      }

      R._setFidgetSpeedUI = setFidgetSpeedUI;
      R._setFidgetToggleUI = setFidgetToggleUI;
    }

    try{
      R._setFidgetSpeedUI && R._setFidgetSpeedUI();
      R._setFidgetToggleUI && R._setFidgetToggleUI();
    }catch(_){}

    return true;
  }

  function wheelCenterClient(){
    try{
      if(!R.wheelWrap) return { x: window.innerWidth/2, y: window.innerHeight/2 };
      var rect = R.wheelWrap.getBoundingClientRect();
      return { x: rect.left + rect.width/2, y: rect.top + rect.height/2 };
    }catch(_){
      return { x: window.innerWidth/2, y: window.innerHeight/2 };
    }
  }

  function clientToAng(ev){
    var c = wheelCenterClient();
    var x = ev.clientX - c.x;
    var y = ev.clientY - c.y;
    return Math.atan2(y, x);
  }

  function getBadgeCenterSVG(){
    var ui = TW.state.ui || {};
    var offX = parseFloat(ui.centerBadgeOffX || 0); if(!isFinite(offX)) offX = 0;
    var offY = parseFloat(ui.centerBadgeOffY || 0); if(!isFinite(offY)) offY = 0;
    return { x: 500 + offX, y: 500 + offY };
  }

  function setBadgeRotate(deg){
    if(!R.centerImg) return;
    TW._fidget.deg = deg;

    var cfg = fidgetCfg();
    if(cfg.snap){
      var notches = 24;
      var step = 360 / notches;
      deg = Math.round(deg / step) * step;
    }

    var c = getBadgeCenterSVG();
    try{
      R.centerImg.setAttribute('transform', 'rotate(' + deg.toFixed(2) + ' ' + c.x.toFixed(2) + ' ' + c.y.toFixed(2) + ')');
    }catch(_){}
  }

  function pulseIfFast(){
    if(!R.fidgetGlass) return;
    var v = Math.abs(TW._fidget.vel || 0);
    var fast = v > 0.055;
    try{
      if(fast) R.wheelWrap.classList.add('tw-fidgetFast');
      else R.wheelWrap.classList.remove('tw-fidgetFast');
    }catch(_){}
  }

  function burstTiny(){
    if(!R.fidgetBurst) return;
    var holder = R.fidgetBurst;
    holder.hidden = false;
    holder.innerHTML = '';

    var c = document.createElement('div');
    c.className = 'tw-fidgetBurstCore';
    holder.appendChild(c);

    for(var i=0;i<10;i++){
      var sp = document.createElement('span');
      sp.className = 'tw-fidgetSpark';
      sp.style.setProperty('--a', String((Math.PI*2*(i/10)) + (Math.random()*0.35)));
      sp.style.setProperty('--d', String(18 + Math.random()*28));
      holder.appendChild(sp);
    }

    holder.classList.remove('go');
    void holder.offsetWidth;
    holder.classList.add('go');

    setTimeout(function(){
      try{ holder.hidden = true; holder.innerHTML = ''; }catch(_){}
    }, 520);
  }

  function stopFidgetMotion(recenter){
    cancelAnimationFrame(TW._fidget.raf);
    TW._fidget.raf = 0;
    TW._fidget.vel = 0;

    if(recenter){
      var from = TW._fidget.deg || 0;
      var to = 0;
      var start = performance.now();
      var dur = 520;

      function easeOut(t){ return 1 - Math.pow(1-t, 3); }

      function frame(t){
        var p = U.clamp((t - start)/dur, 0, 1);
        var e = easeOut(p);
        var wob = (1 - p) * Math.sin(p * Math.PI * 3) * 2.2;
        setBadgeRotate(from + (to-from)*e + wob);
        pulseIfFast();
        if(p < 1) requestAnimationFrame(frame);
        else{
          setBadgeRotate(to);
          try{ R.wheelWrap.classList.remove('tw-fidgetFast'); }catch(_){}
        }
      }
      requestAnimationFrame(frame);
    }else{
      try{ R.wheelWrap.classList.remove('tw-fidgetFast'); }catch(_){}
    }
  }

  function fidgetLoop(t){
    var f = TW._fidget;
    if(!f.on) return;

    var cfg = fidgetCfg();

    if(!f.lastT) f.lastT = t;
    var dt = Math.max(1, t - f.lastT);
    f.lastT = t;

    var fr = cfg.friction;
    var pow = Math.pow(fr, dt / 16.67);
    f.vel *= pow;

    if(Math.abs(f.vel) < 0.00025) f.vel = 0;

    if(f.vel !== 0){
      f.deg += (f.vel * dt * 1000);
      setBadgeRotate(f.deg);
      pulseIfFast();

      if(cfg.tick || (cfg.haptics && hasHaptics())){
        var notch = 24;
        var step = 360 / notch;
        var n = Math.floor((f.deg % 360) / step);
        if(n !== f.lastTickNotch){
          f.lastTickNotch = n;
          if(cfg.tick) tickSound();
          if(cfg.haptics && hasHaptics()) vibe(6);
        }
      }
    }else{
      pulseIfFast();
    }

    f.raf = requestAnimationFrame(fidgetLoop);
  }

  function enterFidgetMode(){
    if(TW._fidget.on) return;
    if(!ensureFidgetEls()) return;

    if(TW.state.ui && TW.state.ui.overlay) return;
    if((TW.state.ui.centerBadgeEditOn||'no') === 'yes') return;
    if(TW._rt && TW._rt.spinning) return;
    if(R.modalBack && !R.modalBack.hidden) return;

    TW._fidget.on = true;
    TW._fidget.lastT = 0;
    TW._fidget.lastTickNotch = 0;

    TW._fidget.deg = TW._fidget.deg || 0;

    try{
      if(R.wrap) R.wrap.classList.add('tw-fidgetOn');
      R.wheelWrap.classList.add('tw-fidgetOn');
    }catch(_){}

    try{
      if(R.fidgetGlass) R.fidgetGlass.hidden = false;
      if(R.fidgetBadge) R.fidgetBadge.hidden = false;
      if(R.fidgetPanel) R.fidgetPanel.hidden = false;
    }catch(_){}

    try{
      if(R.fidgetX){
        R.fidgetX.hidden = true;
        setTimeout(function(){
          if(!TW._fidget.on) return;
          R.fidgetX.hidden = false;
        }, 1200);
      }
    }catch(_){}

    cancelAnimationFrame(TW._fidget.raf);
    TW._fidget.raf = requestAnimationFrame(fidgetLoop);

    try{ burstTiny(); }catch(_){}
    try{
      var cfg = fidgetCfg();
      if(cfg.haptics && hasHaptics()) vibe(10);
      if(cfg.tick) tickSound();
    }catch(_){}
  }

  function exitFidgetMode(reason){
    if(!TW._fidget.on) return;

    TW._fidget.on = false;
    TW._fidget.dragging = false;
    TW._fidget.downPt = null;

    cancelAnimationFrame(TW._fidget.raf);
    TW._fidget.raf = 0;

    try{
      if(R.wrap) R.wrap.classList.remove('tw-fidgetOn');
      if(R.wheelWrap) R.wheelWrap.classList.remove('tw-fidgetOn');
      if(R.wheelWrap) R.wheelWrap.classList.remove('tw-fidgetFast');
    }catch(_){}

    try{
      if(R.fidgetGlass) R.fidgetGlass.hidden = true;
      if(R.fidgetBadge) R.fidgetBadge.hidden = true;
      if(R.fidgetPanel) R.fidgetPanel.hidden = true;
      if(R.fidgetX) R.fidgetX.hidden = true;
      if(R.fidgetBurst){ R.fidgetBurst.hidden = true; R.fidgetBurst.innerHTML = ''; }
    }catch(_){}

    if(reason !== 'spin'){
      stopFidgetMotion(true);
    }else{
      stopFidgetMotion(false);
      setBadgeRotate(0);
    }
  }

  TW.exitFidgetMode = exitFidgetMode;
  TW.enterFidgetMode = enterFidgetMode;

  function bindFidgetMode(){
    if(TW._fidgetBound) return;
    TW._fidgetBound = true;

    function clearHold(){
      var f = TW._fidget;
      f.holdArmed = false;
      if(f.holdRAF) cancelAnimationFrame(f.holdRAF);
      f.holdRAF = 0;
      f.holdT = 0;
      try{
        if(R.fidgetCharge){
          R.fidgetCharge.hidden = true;
          R.fidgetCharge.style.setProperty('--p','0');
        }
      }catch(_){}
    }

    function chargeFrame(t){
      var f = TW._fidget;
      if(!f.holdArmed) return;
      if(!f.holdT) f.holdT = t;
      var dt = t - f.holdT;

      var TH = 750;
      var p = U.clamp(dt / TH, 0, 1);

      try{
        if(R.fidgetCharge){
          R.fidgetCharge.hidden = false;
          R.fidgetCharge.style.setProperty('--p', String(p));
        }
      }catch(_){}

      if(p >= 1){
        clearHold();
        enterFidgetMode();
        return;
      }
      f.holdRAF = requestAnimationFrame(chargeFrame);
    }

    function maybeSwipeExit(ev){
      if(!TW._fidget.on) return false;
      if(!TW._fidget.downPt) return false;
      var dx = (ev.clientX - TW._fidget.downPt.x);
      var dy = (ev.clientY - TW._fidget.downPt.y);
      if(dy > 70 && Math.abs(dx) < 55){
        exitFidgetMode('swipe');
        return true;
      }
      return false;
    }

    function onPointerDown(ev){
      if(!R.centerImg) return;
      if(ev.target !== R.centerImg) return;
      if((TW.state.ui.centerBadgeEditOn||'no') === 'yes') return;
      if(TW._rt && TW._rt.spinning) return;
      if(R.modalBack && !R.modalBack.hidden) return;

      TW._fidget.downPt = { x: ev.clientX, y: ev.clientY, t: performance.now() };

      if(TW._fidget.on){
        var now = performance.now();
        if(!TW._fidget.dragging && (now - (TW._fidget.turboCooldownT||0)) > 170){
          TW._fidget._maybeTurbo = true;
        }

        TW._fidget.dragging = true;
        TW._fidget.lastAng = clientToAng(ev);
        TW._fidget.lastMoveT = performance.now();
        try{ R.centerImg.setPointerCapture && R.centerImg.setPointerCapture(ev.pointerId); }catch(_){}
        TW._fidget.vel = 0;

        ev.preventDefault();
        ev.stopPropagation();
        return;
      }

      TW._fidget.holdArmed = true;
      TW._fidget.holdT = 0;
      TW._fidget.holdRAF = requestAnimationFrame(chargeFrame);
    }

    function onPointerMove(ev){
      if(!R.centerImg) return;
      if(ev.target !== R.centerImg && !TW._fidget.dragging) return;

      if(maybeSwipeExit(ev)) return;

      if(TW._fidget.holdArmed && !TW._fidget.on){
        var dp = TW._fidget.downPt;
        if(dp){
          var mx = ev.clientX - dp.x;
          var my = ev.clientY - dp.y;
          if(Math.abs(mx) > 14 || Math.abs(my) > 14){
            clearHold();
          }
        }
        return;
      }

      if(TW._fidget.on && TW._fidget.dragging){
        ev.preventDefault();
        ev.stopPropagation();

        var a = clientToAng(ev);
        var da = a - TW._fidget.lastAng;
        if(da > Math.PI) da -= 2*Math.PI;
        if(da < -Math.PI) da += 2*Math.PI;

        var now = performance.now();
        var dt = Math.max(1, now - (TW._fidget.lastMoveT || now));

        var degDelta = (da * 180/Math.PI);
        TW._fidget.deg += degDelta;
        setBadgeRotate(TW._fidget.deg);

        var v = (degDelta / dt) / 1000;
        var cfg = fidgetCfg();
        v = U.clamp(v, -cfg.maxVel, cfg.maxVel);
        TW._fidget.vel = v;

        TW._fidget.lastAng = a;
        TW._fidget.lastMoveT = now;

        TW._fidget._maybeTurbo = false;

        var cfg2 = fidgetCfg();
        if(cfg2.tick || (cfg2.haptics && hasHaptics())){
          var notch = 24;
          var step = 360 / notch;
          var n = Math.floor((TW._fidget.deg % 360) / step);
          if(n !== TW._fidget.lastTickNotch){
            TW._fidget.lastTickNotch = n;
            if(cfg2.tick) tickSound();
            if(cfg2.haptics && hasHaptics()) vibe(6);
          }
        }

        pulseIfFast();
      }
    }

    function onPointerUp(ev){
      if(TW._fidget.holdArmed && !TW._fidget.on){
        clearHold();
      }

      if(TW._fidget.on){
        var dp = TW._fidget.downPt;
        var now = performance.now();
        var quick = dp && (now - dp.t < 280);
        var moved = dp && (Math.abs(ev.clientX - dp.x) > 10 || Math.abs(ev.clientY - dp.y) > 10);

        if(quick && !moved && TW._fidget._maybeTurbo){
          TW._fidget._maybeTurbo = false;
          TW._fidget.turboCooldownT = now;
          TW._fidget.vel = U.clamp((TW._fidget.vel || 0) * 1.35 + 0.018, -0.11, 0.11);
          try{ burstTiny(); }catch(_){}
          var cfg = fidgetCfg();
          if(cfg.haptics && hasHaptics()) vibe(10);
        }else if(quick && !moved){
          exitFidgetMode('tap');
        }

        TW._fidget.dragging = false;
        TW._fidget.downPt = null;
        try{ (R.centerImg && R.centerImg.releasePointerCapture) && R.centerImg.releasePointerCapture(ev.pointerId); }catch(_){}
      }
    }

    function attach(){
      if(!R.wheelSvg || !R.centerImg) return false;
      ensureFidgetEls();
      if(R.centerImg.__twFidgetBound) return true;
      R.centerImg.__twFidgetBound = true;

      R.wheelSvg.addEventListener('pointerdown', onPointerDown, { passive:false });
      R.wheelSvg.addEventListener('pointermove', onPointerMove, { passive:false });
      R.wheelSvg.addEventListener('pointerup', onPointerUp, { passive:true });
      R.wheelSvg.addEventListener('pointercancel', onPointerUp, { passive:true });

      if(!TW._fidgetScrollBound){
        TW._fidgetScrollBound = true;
        window.addEventListener('scroll', function(){
          if(!TW._fidget.on) return;
          if(!TW._fidget.dragging){
            exitFidgetMode('scroll');
          }
        }, { passive:true });
      }

      return true;
    }

    var tries = 0;
    (function tryAttach(){
      tries++;
      if(attach()) return;
      if(tries < 40) setTimeout(tryAttach, 80);
    })();
  }

  // =========================================================
  // ✅ END FIDGET MODE
  // =========================================================

  // runtime flags
  TW._rt = TW._rt || {
    spinning: false,
    raf: 0,
    spinStart: 0,
    spinDur: 0,
    startDeg: 0,
    endDeg: 0,
    chosenIdx: -1,
    multiRemaining: 0,
    multiActive: false,

    // ✅ keep a handle to the current spin audio so we can hard-stop it
    spinAudio: null,
    spinAudioTO: 0
  };

  // --- weighted selection (crypto RNG + correct cumulative weights) ---
  function pickWeightedIndex(){
    var segs = TW.state.segments || [];
    var n = segs.length;
    if(!n) return -1;

    var sum = 0;
    for(var i=0;i<n;i++){
      var w = parseFloat(segs[i].weight);
      if(!(w > 0)) w = 1;
      sum += w;
    }
    if(!(sum > 0)) return (n-1);

    var x = U.rand01() * sum;
    var acc = 0;
    for(var j=0;j<n;j++){
      var w2 = parseFloat(segs[j].weight);
      if(!(w2 > 0)) w2 = 1;
      acc += w2;
      if(x < acc) return j;
    }
    return n-1;
  }

  // ✅ Make speed differences WAY more dramatic
  function speedConfig(){
    var s = TW.state.ui.speed || 'normal';
    // Apple devices can feel noticeably slower with the exact same 5s timing,
    // so we shorten the classic spin slightly there without changing the turn spread.
    var dur = isIOS() ? 4300 : 5000;
    if(s === 'slow')  return { dur: dur, extraTurns: 12 };
    if(s === 'turbo') return { dur: dur, extraTurns: 38 };
    return { dur: dur, extraTurns: 22 };
  }

  function activeSpinExperience(){
    return String((TW.state && TW.state.ui && TW.state.ui.spinExperience) || 'classic');
  }

  function shouldUseSpinExperience(){
    return activeSpinExperience() !== 'classic';
  }

  function shouldForceExperienceConfetti(){
    return shouldUseSpinExperience();
  }

  function easeInOutCubic(t){
    return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2;
  }

  function easeOutBack(t){
    var c1 = 1.70158;
    var c3 = c1 + 1;
    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
  }

  function ensureSpinFxLayer(){
    try{
      TW._rt = TW._rt || {};
      if(TW._rt.spinFxLayer && TW._rt.spinFxLayer.parentNode) return TW._rt.spinFxLayer;
      var layer = document.createElement('div');
      layer.setAttribute('aria-hidden','true');
      layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:999998;opacity:0;transition:opacity .18s ease;background:radial-gradient(circle at 50% 50%, rgba(255,248,238,0.03) 0%, rgba(0,0,0,0.0) 34%, rgba(0,0,0,0.0) 100%);';
      document.body.appendChild(layer);
      TW._rt.spinFxLayer = layer;
      return layer;
    }catch(_){ return null; }
  }

  function setSpinFx(opts){
    opts = opts || {};
    var layer = ensureSpinFxLayer();
    if(!layer) return;
    var opacity = (opts.opacity == null) ? 0 : opts.opacity;
    var inner = (opts.inner == null) ? 0.06 : opts.inner;
    var outer = (opts.outer == null) ? opacity : opts.outer;
    layer.style.opacity = String(U.clamp(opacity, 0, 1));
    layer.style.background = 'radial-gradient(circle at 50% 50%, rgba(255,248,238,' + inner.toFixed(3) + ') 0%, rgba(10,12,18,' + (outer*0.55).toFixed(3) + ') 34%, rgba(0,0,0,' + outer.toFixed(3) + ') 100%)';
  }

  function clearSpinFx(){
    setSpinFx({ opacity:0, inner:0.02, outer:0 });
  }

  function getMainSpinClipMs(){
    try{
      var s = (TW.CONST && TW.CONST.MAIN_SPIN_SOUND) ? TW.CONST.MAIN_SPIN_SOUND : null;
      return Math.max(3200, ((s && s.clipMs) | 0) || 5000);
    }catch(_){ return 5000; }
  }

  function runExperienceSpin(idx, opts){
    opts = opts || {};
    if(TW._rt.spinning) return;

    var exp = activeSpinExperience();
    var mainClipMs = getMainSpinClipMs();
    var baseDur = Math.max(3450, mainClipMs - 120);
    var durMap = {
      fakeout_frenzy: baseDur,
      blackout_drop: baseDur,
      reactor_surge: baseDur
    };
    var extraTurnsMap = {
      fakeout_frenzy: 31,
      blackout_drop: 27,
      reactor_surge: 47
    };

    var startNorm = normDeg(R.wheelRotateDeg || 0);
    TW._rt.useCssRotate = true; // All devices: composite the complete wheel SVG for smooth rotation
    setWheelDeg(startNorm);

    TW._rt.spinning = true;
    if(R.btnSpin) R.btnSpin.classList.remove('tw-spinIdlePulse');
    TW._rt.spinStart = performance.now();
    TW._rt.spinDur = durMap[exp] || baseDur;
    TW._rt.startDeg = startNorm;
    TW._rt.chosenIdx = idx;
    TW._rt.endDeg = computeTargetEndDeg(idx, extraTurnsMap[exp] || 28);
    TW._rt.experience = exp;
    TW._rt.blackoutMuted = false;
    TW._rt.expFinalPulseDone = false;
    TW._rt.expShockPlayed = false;

    var segs = TW.state.segments || [];
    var n = Math.max(1, segs.length);
    var step = 360 / n;
    var blackoutFakeIdx = (idx + (n > 2 ? -1 : 1) + n) % n;
    if(blackoutFakeIdx === idx) blackoutFakeIdx = (idx + 1) % n;
    var blackoutFakeEnd = computeTargetEndDeg(blackoutFakeIdx, extraTurnsMap[exp] || 27);

    playSpinSound(TW._rt.spinDur);
    if(R.wheelWrap) R.wheelWrap.classList.add('tw-spinning');

    function frame(t){
      var p = U.clamp((t - TW._rt.spinStart) / TW._rt.spinDur, 0, 1);
      var deg = TW._rt.startDeg;
      var end = TW._rt.endDeg;

      if(exp === 'fakeout_frenzy'){
        var fake1 = end - (step * 2.18);
        var fake2 = end - (step * 1.08);
        var fake3 = end - (step * 0.42);
        var fake4 = end - (step * 0.07);
        if(p < 0.44){
          deg = TW._rt.startDeg + (fake1 - TW._rt.startDeg) * easeOutQuint(p / 0.44);
          setSpinFx({ opacity:0.04 + 0.05*p, inner:0.05, outer:0.04 + 0.04*p });
        }else if(p < 0.57){
          var pp = (p - 0.44) / 0.13;
          deg = fake1 + Math.sin(pp * Math.PI * 8.6) * (0.55 + 0.45*(1-pp)) * (step * 0.18);
          setSpinFx({ opacity:0.16 + (0.16 * (1 - pp)), inner:0.07, outer:0.11 + (0.10 * (1 - pp)) });
          if(pp > 0.14 && !TW._rt.expShockPlayed){ TW._rt.expShockPlayed = true; vibe(12); }
        }else if(p < 0.72){
          var pp2 = (p - 0.57) / 0.15;
          deg = fake1 + (fake2 - fake1) * easeInOutCubic(pp2);
          setSpinFx({ opacity:0.08 + 0.15 * pp2, inner:0.06, outer:0.05 + 0.10 * pp2 });
        }else if(p < 0.82){
          var pp3 = (p - 0.72) / 0.10;
          deg = fake2 + Math.sin(pp3 * Math.PI * 7.2) * (1 - pp3*0.55) * (step * 0.13);
          setSpinFx({ opacity:0.18 + (0.20 * (1 - pp3)), inner:0.08, outer:0.14 + (0.13 * (1 - pp3)) });
        }else if(p < 0.90){
          var pp4 = (p - 0.82) / 0.08;
          deg = fake2 + (fake3 - fake2) * easeInOutCubic(pp4);
          setSpinFx({ opacity:0.20 + 0.18 * pp4, inner:0.09, outer:0.16 + 0.12 * pp4 });
        }else if(p < 0.965){
          var pp5 = (p - 0.90) / 0.065;
          deg = fake3 + (fake4 - fake3) * easeOutQuint(pp5) + Math.sin(pp5 * Math.PI * 10.0) * (1 - pp5) * (step * 0.075);
          setSpinFx({ opacity:0.30 + (0.22 * (1 - pp5)), inner:0.10, outer:0.21 + (0.16 * (1 - pp5)) });
          if(pp5 > 0.28 && !TW._rt.expFinalPulseDone){
            TW._rt.expFinalPulseDone = true;
            vibe(22);
          }
        }else{
          var pp6 = (p - 0.965) / 0.035;
          deg = fake4 + (end - fake4) * easeOutBack(pp6);
          setSpinFx({ opacity:0.44 * (1 - pp6), inner:0.12 - (0.04 * pp6), outer:0.28 * (1 - pp6) });
        }
      }else if(exp === 'blackout_drop'){
        var hold = blackoutFakeEnd;
        if(p < 0.74){
          deg = TW._rt.startDeg + (hold - TW._rt.startDeg) * easeOutQuint(p / 0.74);
          setSpinFx({ opacity:0.01 + 0.02*p, inner:0.04, outer:0.01 + 0.02*p });
        }else if(p < 0.84){
          var pp7 = (p - 0.74) / 0.10;
          deg = hold + Math.sin(pp7 * Math.PI * 3.5) * (step * 0.025);
          setSpinFx({ opacity:0.38 + 0.50 * pp7, inner:0.03, outer:0.34 + 0.54 * pp7 });
          if(pp7 > 0.08 && !TW._rt.blackoutMuted){
            TW._rt.blackoutMuted = true;
            stopSpinSoundNow();
            vibe(16);
          }
        }else if(p < 0.955){
          deg = hold + Math.sin(t / 130) * (step * 0.008);
          setSpinFx({ opacity:0.96, inner:0.01, outer:0.98 });
        }else{
          var pp8 = (p - 0.955) / 0.045;
          deg = hold + (end - hold) * easeOutBack(pp8);
          setSpinFx({ opacity:0.98 * (1 - pp8), inner:0.03 + (0.12 * pp8), outer:0.98 * (1 - pp8) });
          if(pp8 > 0.05 && !TW._rt.expFinalPulseDone){
            TW._rt.expFinalPulseDone = true;
            vibe(28);
          }
        }
      }else if(exp === 'reactor_surge'){
        if(p < 0.08){
          deg = TW._rt.startDeg + (end - TW._rt.startDeg) * 0.34 * easeOutQuint(p / 0.08);
        }else if(p < 0.19){
          var pp9 = (p - 0.08) / 0.11;
          deg = TW._rt.startDeg + (end - TW._rt.startDeg) * (0.34 + 0.10 * pp9) + Math.sin(t / 11.5) * (step * 0.18);
        }else if(p < 0.35){
          var pp10 = (p - 0.19) / 0.16;
          deg = TW._rt.startDeg + (end - TW._rt.startDeg) * (0.44 + 0.22 * easeOutQuint(pp10));
        }else if(p < 0.49){
          var pp11 = (p - 0.35) / 0.14;
          deg = TW._rt.startDeg + (end - TW._rt.startDeg) * (0.66 + 0.07 * pp11) + Math.sin(t / 12.5) * (step * 0.19) + Math.sin(t / 5.8) * (step * 0.05);
        }else if(p < 0.66){
          var pp12 = (p - 0.49) / 0.17;
          deg = TW._rt.startDeg + (end - TW._rt.startDeg) * (0.73 + 0.13 * easeInOutCubic(pp12));
        }else if(p < 0.88){
          var pp13 = (p - 0.66) / 0.22;
          var base = TW._rt.startDeg + (end - TW._rt.startDeg) * (0.86 + 0.07 * pp13);
          var amp = (0.78 - (0.56 * pp13)) * step;
          deg = base + Math.sin(t / 9.5) * amp + Math.sin(t / 4.8) * amp * 0.30;
        }else if(p < 0.975){
          var pp14 = (p - 0.88) / 0.095;
          var base2 = end - (step * 0.09) + (step * 0.05 * pp14);
          deg = base2 + Math.sin(t / 7.8) * (step * 0.09 * (1 - pp14));
          if(pp14 > 0.16 && !TW._rt.expFinalPulseDone){
            TW._rt.expFinalPulseDone = true;
            vibe(30);
          }
        }else{
          var pp15 = (p - 0.975) / 0.025;
          deg = (end - step * 0.04) + (step * 0.04) * easeOutBack(pp15);
        }
        var reactorGlow = p < 0.92 ? (0.24 + 0.42 * Math.abs(Math.sin(t / 38))) : (0.52 * (1 - ((p - 0.92) / 0.08)));
        setSpinFx({ opacity:reactorGlow, inner:0.12 + reactorGlow * 0.24, outer:reactorGlow });
      }

      setWheelDeg(deg);

      if(p < 1){
        TW._rt.raf = requestAnimationFrame(frame);
      }else{
        setWheelDeg(end);
        try{ if(R.wheelGroup) R.wheelGroup.style.willChange = ''; if(R.wheelSvg) R.wheelSvg.style.willChange = ''; }catch(_){ }
        if(R.wheelWrap) R.wheelWrap.classList.remove('tw-spinning');
        clearSpinFx();
        clearSliceWin();
        setWinningSlice(idx);
        TW._rt.spinning = false;
        if(R.btnSpin) R.btnSpin.classList.add('tw-spinIdlePulse');
        TW._rt.blackoutMuted = false;
        TW._rt.expFinalPulseDone = false;
        TW._rt.expShockPlayed = false;
        TW._rt.experience = '';
        stopSpinSoundNow();
        postSpinToCounter({
          winnerLabel: (TW.state.segments && TW.state.segments[idx] && TW.state.segments[idx].label) ? TW.state.segments[idx].label : ""
        });
        openWinnerModal(idx);
      }
    }

    TW._rt.raf = requestAnimationFrame(frame);
  }

  // =========================================================
  // ✅ PERF: iOS Safari/Chrome tends to struggle with frequent SVG setAttribute() transforms.
  // For iOS we rotate the wheel group using CSS transforms (GPU/compositor friendly).
  // =========================================================
  function isIOS(){
    try{
      var ua = navigator.userAgent || '';
      return /iPad|iPhone|iPod/.test(ua) || (ua.indexOf('Macintosh') >= 0 && 'ontouchend' in document);
    }catch(_){ return false; }
  }


  function normDeg(deg){
    deg = deg % 360;
    if(deg < 0) deg += 360;
    return deg;
  }

  function setWheelDeg(deg){
    var g = R.wheelGroup;
    if(!g) return;
    R.wheelRotateDeg = deg;

    // Apple performance path: rotate the complete SVG as one composited layer.
    // Rotating the root SVG avoids Safari recalculating every path in the <g>
    // and also avoids the old SVG-group bounding-box origin jump.
    if(TW._rt && TW._rt.useCssRotate && R.wheelSvg){
      try{
        g.removeAttribute('transform');
        g.style.transform = '';
        g.style.willChange = '';
        R.wheelSvg.style.transformOrigin = '50% 50%';
        R.wheelSvg.style.webkitTransformOrigin = '50% 50%';
        R.wheelSvg.style.willChange = 'transform';
        R.wheelSvg.style.transform = 'translateZ(0) rotate(' + deg + 'deg)';
        R.wheelSvg.style.webkitTransform = 'translateZ(0) rotate(' + deg + 'deg)';
        return;
      }catch(_){ /* fall through */ }
    }

    // Fallback path only if root-SVG compositing is unavailable.
    if(R.wheelSvg){
      R.wheelSvg.style.transform = '';
      R.wheelSvg.style.webkitTransform = '';
      R.wheelSvg.style.willChange = '';
    }
    g.setAttribute('transform','rotate(' + deg + ' 500 500)');
  }

  function easeOutQuint(t){ return 1 - Math.pow(1-t, 5); }

  function clearSliceWin(){
    if(R._sliceNodes){
      R._sliceNodes.forEach(function(node){
        node.classList.remove('tw-winSlice');
        try{ node.removeAttribute('transform'); }catch(_){}
      });
    }
  }

  function applySliceAlive(t, p){
    if(!R._sliceNodes || !R._sliceVecs) return;
    var n = R._sliceNodes.length;
    if(n <= 1) return;

    var mid = 1 - Math.abs(0.5 - p) * 2;
    var amp = 14 + mid * 28;
    var wob = Math.sin(t / 85) * 0.65 + Math.sin(t / 43) * 0.45;

    for(var i=0;i<n;i++){
      var node = R._sliceNodes[i];
      var v = R._sliceVecs[i] || { x:0, y:0 };

      var phase = (i * 0.60) + (t / 120);
      var bump01 = (0.5 + 0.5 * Math.sin(phase));
      var bump = (0.55 + 0.45 * bump01) * amp;

      var tx = v.x * bump * 0.78;
      var ty = v.y * bump * 0.78;

      tx += wob * 1.6;
      ty -= wob * 1.1;

      var sc = 1 + (bump01 * 0.035) * (0.35 + mid*0.65);

      node.setAttribute('transform',
        'translate(' + tx.toFixed(2) + ' ' + ty.toFixed(2) + ') scale(' + sc.toFixed(3) + ')'
      );
    }
  }

  function setWinningSlice(idx){
    clearSliceWin();
    if(R._sliceNodes && R._sliceNodes[idx]){
      var node = R._sliceNodes[idx];
      node.classList.add('tw-winSlice');

      var v = (R._sliceVecs && R._sliceVecs[idx]) ? R._sliceVecs[idx] : { x:0, y:0 };

      var MAX_POP = 18;

      function applyPop(pop, scale){
        pop = U.clamp(pop, 0, MAX_POP);
        var tx = v.x * pop;
        var ty = v.y * pop;
        node.setAttribute('transform',
          'translate(' + tx.toFixed(2) + ' ' + ty.toFixed(2) + ') scale(' + scale.toFixed(3) + ')'
        );
      }

      applyPop(10, 1.04);

      requestAnimationFrame(function(){
        applyPop(18, 1.12);
        playWinSound();

        setTimeout(function(){
          if(!node.classList.contains('tw-winSlice')) return;
          applyPop(16, 1.08);
        }, 160);
      });
    }
  }

  // --- audio helpers ---
  function stopSpinSoundNow(){
    try{
      if(TW._rt.spinAudioTO){
        clearTimeout(TW._rt.spinAudioTO);
        TW._rt.spinAudioTO = 0;
      }
    }catch(_){}

    try{
      var a = TW._rt.spinAudio;
      if(a){
        try{ if(a.__twClipTO){ clearTimeout(a.__twClipTO); a.__twClipTO = 0; } }catch(_){}
        try{ a.__twApplePrimeToken = 0; a.__twApplePriming = false; }catch(_){}
        a.pause();
        a.currentTime = 0;
      }
    }catch(_){}

    TW._rt.spinAudio = null;
  }

  function _makeAudioEl(url){
    try{
      var a = new Audio(url);
      a.preload = 'auto';
      a.playsInline = true;
      try{ a.setAttribute('playsinline', ''); a.setAttribute('webkit-playsinline', ''); }catch(_){ }
      return a;
    }catch(_){ return null; }
  }

  function _isAppleFxUrl(url){
    try{
      if(!url) return false;
      if(!isIOS()) return false;
      var s = String(url || '');
      if(String((((TW.CONST || {}).MAIN_SPIN_SOUND || {}).url) || '') === s) return true;
      if(String((((TW.CONST || {}).RETURN_SOUND || {}).url) || '') === s) return true;
      var pre = TW.CONST && TW.CONST.PRESPIN_SOUNDS || [];
      for(var i=0;i<pre.length;i++) if(String(pre[i] && pre[i].url || '') === s) return true;
      var win = TW.CONST && TW.CONST.CELEBRATION_SOUNDS || [];
      for(var j=0;j<win.length;j++) if(String(win[j] && win[j].url || '') === s) return true;
      return false;
    }catch(_){ return false; }
  }

  function _forceVolumeOnApple(a, vol){
    try{
      if(!a) return;
      var v = U.clamp(vol == null ? 0.7 : vol, 0, 1);
      function apply(){
        try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
        try{ a.volume = v; }catch(_){ }
      }
      apply();
      try{ a.onloadedmetadata = apply; }catch(_){ }
      try{ a.oncanplay = apply; }catch(_){ }
      try{ a.onplay = apply; }catch(_){ }
      try{ a.onplaying = apply; }catch(_){ }
    }catch(_){ }
  }

  function _getReusableAudio(url){
    try{
      if(!url) return null;

      TW._audCache = TW._audCache || { byUrl: Object.create(null) };
      var map = TW._audCache.byUrl;

      var a = map[url];
      if(!a){
        a = _makeAudioEl(url);
        map[url] = a;
      }

      // APPLE / iOS CHROME + SAFARI FIX:
      // Reuse the exact media element primed during the user gesture.
      // Fresh Audio() at delayed winner time is commonly blocked by iOS.
      if(_isAppleFxUrl(url)){
        return a;
      }

      try{
        if(a && !a.paused && !a.ended){
          return _makeAudioEl(url);
        }
      }catch(_){}

      return a;
    }catch(_){
      return null;
    }
  }

  function playClip(url, volume, clipMs){
    try{
      try{ if(TW && typeof TW.isSoundEnabled === 'function' && !TW.isSoundEnabled()) return; }catch(_){ }
      var a = _getReusableAudio(url);
      if(!a) return;

      try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
      a.volume = U.clamp(volume == null ? 0.7 : volume, 0, 1);
      try{ if(isIOS()) _forceVolumeOnApple(a, volume); }catch(_){ }

      // If this element was being Apple-primed, the real playback now owns it.
      // This prevents the priming cleanup from pausing the actual beginning/winner sound.
      try{ a.__twApplePrimeToken = 0; a.__twApplePriming = false; }catch(_){}
      try{ if(a.__twClipTO){ clearTimeout(a.__twClipTO); a.__twClipTO = 0; } }catch(_){}

      // iOS: setting currentTime can throw if not yet loaded; ignore
      try{ a.currentTime = 0; }catch(_){}

      // Track last fx audio for volume hot-apply (Part5 patch can reference this)
      try{ TW._rt = TW._rt || {}; TW._rt.lastWinAudio = a; }catch(_){}

      var ms = Math.max(0, clipMs|0);

      // ✅ Robust clipping for iOS:
      // If playback is blocked and starts later (after unlock), a simple timeout can fire too early.
      // So we arm a "playing" listener to pause after ms from actual playback start.
      var didArm = false;
      function armClip(){
        if(didArm) return;
        didArm = true;
        if(!(ms > 0)) return;

        // pause after ms once playback actually starts
        var to2 = setTimeout(function(){
          try{ a.pause(); }catch(_){}
          try{ a.currentTime = 0; }catch(_){}
        }, ms);

        // safety: clear listener reference
        try{
          a.__twClipTO = to2;
        }catch(_){}
      }

      if(ms > 0){
        try{
          var onPlaying = function(){
            try{ a.removeEventListener('playing', onPlaying); }catch(_){}
            armClip();
          };
          a.addEventListener('playing', onPlaying);
        }catch(_){}
        // also a secondary safety timeout in case 'playing' never fires
        setTimeout(function(){
          armClip();
        }, 120);
      }

      try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){ }
      var p = a.play();
      if(p && p.catch) p.catch(function(){});

      // legacy immediate clip (still helps on most browsers)
      if(ms > 0){
        setTimeout(function(){
          try{ a.pause(); }catch(_){}
          try{ a.currentTime = 0; }catch(_){}
        }, ms + 40);
      }
    }catch(_){}
  }

  function playSpinSound(forDurMs){
    try{ if(TW && typeof TW.isSoundEnabled === 'function' && !TW.isSoundEnabled()) return; }catch(_){ }
    stopSpinSoundNow();

    // Main spin sound is fixed (not selectable in menu)
    var s = (TW.CONST && TW.CONST.MAIN_SPIN_SOUND) ? TW.CONST.MAIN_SPIN_SOUND : null;
    if(!s || !s.url) return;

    try{
      var a = _getReusableAudio(s.url);
      if(!a) return;

      // Always apply current volume before play (iOS is picky)
      try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
      var spinVol = (TW.state.ui.spinVolume == null || TW.state.ui.spinVolume <= 0.01) ? 0.62 : TW.state.ui.spinVolume;
      a.volume = U.clamp(spinVol, 0, 1);
      try{ if(isIOS()) _forceVolumeOnApple(a, spinVol); }catch(_){ }

      var maxMs = (s.clipMs|0) || 5000;
      var wantMs = Math.max(200, (forDurMs|0) + 140);
      var clipMs = Math.min(maxMs, wantMs);

      TW._rt.spinAudio = a;

      // If this element was being Apple-primed, the real spin playback now owns it.
      try{ a.__twApplePrimeToken = 0; a.__twApplePriming = false; }catch(_){}
      try{ if(a.__twClipTO){ clearTimeout(a.__twClipTO); a.__twClipTO = 0; } }catch(_){}

      try{ a.currentTime = 0; }catch(_){ }
      try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){ }
      var p = a.play();
      if(p && p.catch) p.catch(function(){});

      TW._rt.spinAudioTO = setTimeout(function(){
        stopSpinSoundNow();
      }, clipMs);
    }catch(_){ }
  }

  function playPreSpinSound(){
    try{
      try{ if(TW && typeof TW.isSoundEnabled === 'function' && !TW.isSoundEnabled()) return; }catch(_){ }
      var id = TW.state.ui.spinSoundId || 'retro_reactor';
      var list = TW.CONST.PRESPIN_SOUNDS || [];
      var s = list.find(function(x){ return x.id === id; }) || list[0];
      if(!s || !s.url) return;
      var vol = (TW.state && TW.state.ui && TW.state.ui.spinVolume != null && TW.state.ui.spinVolume > 0.01) ? TW.state.ui.spinVolume : 0.62;
      playClip(s.url, vol, s.clipMs);
    }catch(_){ }
  }

  function playWinSound(){
    try{ if(TW && typeof TW.isSoundEnabled === 'function' && !TW.isSoundEnabled()) return; }catch(_){ }
    var id = TW.state.ui.winSoundId || 'air_zing';
    var s = (TW.CONST.CELEBRATION_SOUNDS||[]).find(function(x){ return x.id === id; }) || (TW.CONST.CELEBRATION_SOUNDS||[])[0];
    var vol = (TW.state && TW.state.ui && TW.state.ui.winVolume != null && TW.state.ui.winVolume > 0.01) ? TW.state.ui.winVolume : 0.92;
    playClip(s.url, vol, s.clipMs);
  }

  function playReturnSound(){
    try{ if(TW && typeof TW.isSoundEnabled === 'function' && !TW.isSoundEnabled()) return; }catch(_){ }
    var rs = TW.CONST && TW.CONST.RETURN_SOUND;
    if(!rs || !rs.url) return;
    var vol = (TW.state.ui && TW.state.ui.spinVolume != null && TW.state.ui.spinVolume > 0.01) ? TW.state.ui.spinVolume : 0.62;
    playClip(rs.url, vol, rs.clipMs || 1000);
  }

  // Expose sound helpers so Part5 can gate/patch reliably
  TW.playSpinSound = playSpinSound;
  TW.playPreSpinSound = playPreSpinSound;
  TW.playWinSound = playWinSound;
  TW.playCelebrationSound = playWinSound;
  TW.playReturnSound = playReturnSound;


  // --- celebration effects matching wheel / winner / custom colors ---
  function runConfetti(force){
    if(!force && (TW.state.ui.confettiOn||'yes') !== 'yes') return;

    var ui = TW.state && TW.state.ui ? TW.state.ui : {};
    var canUseCreatorLab = TW.access && TW.access.hasPlan ? TW.access.hasPlan('vortex_pro') : true;
    var imgSrc = canUseCreatorLab ? String(ui.spinBizConfettiImage || '').trim() : '';
    var mode = canUseCreatorLab ? String(ui.spinBizConfettiMode || 'standard') : 'standard';
    if(mode === 'emoji') mode = 'standard';

    var selectedEffect = String(ui.spinBizCelebrationEffect || 'classic');
    var opts = {
      // Only Classic becomes the rotating swirl. Burst, Cannons, Rain and
      // Sparkles retain their own original movement patterns.
      effect: selectedEffect === 'classic' ? 'standard-swirl' : selectedEffect,
      intensity: String(ui.spinBizCelebrationIntensity || 'standard'),
      colorMode: String(ui.spinBizCelebrationColor || 'wheel'),
      customColor: String(ui.spinBizCelebrationCustomColor || 'ff4fa3'),
      mode: mode,
      image: null
    };

    if(imgSrc && (mode === 'logo' || mode === 'mixed')){
      var logo = new Image();
      logo.crossOrigin = 'anonymous';
      logo.onload = function(){ opts.image = logo; runPremiumCelebration(opts); };
      logo.onerror = function(){ runPremiumCelebration(opts); };
      logo.src = imgSrc;
      return;
    }

    runPremiumCelebration(opts);
  }

  function getCelebrationColors(colorMode, customColor){
    var segs = TW.state.segments || [];
    var colors = segs.map(function(s){ return s.color; }).filter(Boolean);
    if(!colors.length) colors = TW.CONST.PALETTE.slice(0,6);
    if(colorMode === 'winner' && TW.state._meta && TW.state._meta.lastWinnerIdx != null){
      var winner = segs[TW.state._meta.lastWinnerIdx];
      if(winner && winner.color) colors = [winner.color];
    }else if(colorMode === 'custom'){
      var custom = String(customColor || 'ff4fa3').replace('#','');
      if(/^[0-9a-fA-F]{6}$/.test(custom)) colors = ['#' + custom];
    }
    return colors;
  }

  function runPremiumFreeCelebration(){
    runPremiumCelebration({ effect:'classic', intensity:'standard', colorMode:'wheel', customColor:'ff4fa3', mode:'standard', image:null });
  }

  function runPremiumCelebration(opts){
    opts = opts || {};
    var effect = String(opts.effect || 'classic');
    var intensity = String(opts.intensity || 'standard');
    var mode = String(opts.mode || 'standard');
    var img = opts.image || null;
    var colors = getCelebrationColors(String(opts.colorMode || 'wheel'), opts.customColor);

    var old = document.querySelector('.tw-premiumCelebration');
    if(old && old.parentNode) old.parentNode.removeChild(old);

    var center = getWheelCenter();
    var root = document.createElement('div');
    root.className = 'tw-premiumCelebration tw-premiumCelebration--' + effect + ' tw-premiumCelebration--' + intensity;
    root.style.setProperty('--tw-celebrate-x', center.x + 'px');
    root.style.setProperty('--tw-celebrate-y', center.y + 'px');
    root.style.setProperty('--tw-wheel-size', center.size + 'px');
    root.setAttribute('aria-hidden', 'true');

    var glow = document.createElement('div');
    glow.className = 'tw-premiumCelebration__glow';
    root.appendChild(glow);

    if(effect !== 'rain' && effect !== 'standard-swirl'){
      var ringA = document.createElement('div');
      ringA.className = 'tw-premiumCelebration__ring tw-premiumCelebration__ring--a';
      root.appendChild(ringA);
      var ringB = document.createElement('div');
      ringB.className = 'tw-premiumCelebration__ring tw-premiumCelebration__ring--b';
      root.appendChild(ringB);
    }

    var base = intensity === 'light' ? 24 : (intensity === 'huge' ? 130 : 64);
    if(isIOS()) base = Math.max(intensity === 'light' ? 16 : 28, Math.round(base * .72));
    if(img && mode === 'logo') base = Math.max(20, Math.round(base * .72));
    var intensityScale = intensity === 'light' ? .72 : (intensity === 'huge' ? 1.48 : 1);

    function addPiece(i, config){
      config = config || {};
      var piece = document.createElement(img && (mode === 'logo' || (mode === 'mixed' && i % 4 === 0)) ? 'img' : 'i');
      var useImage = piece.tagName === 'IMG';
      var kind = useImage ? 'image' : (config.kind || (i % 7 === 0 ? 'spark' : (i % 5 === 0 ? 'dot' : 'ribbon')));
      piece.className = 'tw-premiumCelebration__piece tw-premiumCelebration__piece--' + kind;
      if(useImage){ piece.src = img.src; piece.alt = ''; piece.decoding = 'async'; }
      piece.style.setProperty('--tw-start-x', (config.startX || 0).toFixed(1) + 'px');
      piece.style.setProperty('--tw-start-y', (config.startY || 0).toFixed(1) + 'px');
      piece.style.setProperty('--tw-px', (config.dx || 0).toFixed(1) + 'px');
      piece.style.setProperty('--tw-py', (config.dy || 0).toFixed(1) + 'px');
      piece.style.setProperty('--tw-mid-x', (config.midX != null ? config.midX : (config.dx || 0) * .52).toFixed(1) + 'px');
      piece.style.setProperty('--tw-mid-y', (config.midY != null ? config.midY : (config.dy || 0) * .52).toFixed(1) + 'px');
      piece.style.setProperty('--tw-fall', (config.fall || 0).toFixed(1) + 'px');
      piece.style.setProperty('--tw-spin', ((U.rand01()-.5)*(useImage ? 420 : 900)).toFixed(0) + 'deg');
      piece.style.setProperty('--tw-delay', ((config.delay != null ? config.delay : U.rand01()*.16)).toFixed(3) + 's');
      piece.style.setProperty('--tw-life', ((config.life != null ? config.life : 1.55 + U.rand01()*.65)).toFixed(2) + 's');
      piece.style.setProperty('--tw-piece-color', colors[i % colors.length]);
      piece.style.setProperty('--tw-piece-scale', ((config.scale != null ? config.scale : .72 + U.rand01()*.7) * intensityScale).toFixed(2));
      root.appendChild(piece);
    }

    for(var i=0;i<base;i++){
      if(effect === 'cannons'){
        var left = i % 2 === 0;
        var startX = left ? -center.x - 18 : (window.innerWidth - center.x) + 18;
        var startY = window.innerHeight - center.y - 30 + U.rand01()*35;
        addPiece(i, {
          startX:startX,
          startY:startY,
          dx:(left ? 1 : -1) * (window.innerWidth * (.34 + U.rand01()*.28)),
          dy:-window.innerHeight * (.48 + U.rand01()*.30),
          fall:window.innerHeight * (.35 + U.rand01()*.42),
          life:2.0 + U.rand01()*.65,
          delay:U.rand01()*.18
        });
      }else if(effect === 'standard-swirl'){
        // A two-armed expanding vortex with a genuine curved midpoint. This is
        // intentionally unlike the radial center burst and the other effects.
        var swirlArm = (i % 2) * Math.PI;
        var swirlAngle = swirlArm + (Math.PI * 6 * i / Math.max(1, base)) + U.rand01() * .18;
        var swirlStartRadius = center.size * (.035 + U.rand01() * .035);
        var swirlMidRadius = center.size * (.30 + U.rand01() * .15);
        var swirlEndRadius = center.size * (.72 + U.rand01() * .48);
        var swirlMidAngle = swirlAngle + 1.45 + U.rand01() * .35;
        var swirlEndAngle = swirlAngle + 2.75 + U.rand01() * .55;
        addPiece(i, {
          startX:Math.cos(swirlAngle) * swirlStartRadius,
          startY:Math.sin(swirlAngle) * swirlStartRadius,
          midX:Math.cos(swirlMidAngle) * swirlMidRadius,
          midY:Math.sin(swirlMidAngle) * swirlMidRadius,
          dx:Math.cos(swirlEndAngle) * swirlEndRadius,
          dy:Math.sin(swirlEndAngle) * swirlEndRadius,
          fall:center.size * (.16 + U.rand01()*.24),
          life:(intensity === 'huge' ? 2.9 : (intensity === 'light' ? 1.9 : 2.45)) + U.rand01()*.45,
          delay:(i % 18) * .028,
          scale:.72 + U.rand01()*.68
        });
      }else if(effect === 'rain'){
        addPiece(i, {
          startX:(U.rand01()*window.innerWidth) - center.x,
          startY:-center.y - 40 - U.rand01()*window.innerHeight*.28,
          dx:(U.rand01()-.5)*110,
          dy:window.innerHeight * (.62 + U.rand01()*.30),
          fall:window.innerHeight * (.18 + U.rand01()*.18),
          life:2.35 + U.rand01()*.75,
          delay:U.rand01()*.55,
          scale:.65 + U.rand01()*.65
        });
      }else if(effect === 'sparkles'){
        var sx = (U.rand01()*window.innerWidth) - center.x;
        var sy = (U.rand01()*window.innerHeight) - center.y;
        addPiece(i, {
          startX:sx,
          startY:sy,
          dx:(U.rand01()-.5)*34,
          dy:(U.rand01()-.5)*30,
          fall:0,
          life:1.45 + U.rand01()*1.1,
          delay:U.rand01()*.55,
          kind:'spark',
          scale:.55 + U.rand01()*1.0
        });
      }else{
        var spread = effect === 'burst' ? Math.PI*2 : Math.PI*1.84;
        var startAngle = effect === 'burst' ? -Math.PI : -Math.PI*.92;
        var angle = startAngle + spread*(i/Math.max(1,base-1)) + (U.rand01()-.5)*.22;
        var distance = center.size * (effect === 'burst' ? (.72 + U.rand01()*.88) : (.62 + U.rand01()*.72));
        addPiece(i, {
          dx:Math.cos(angle)*distance,
          dy:Math.sin(angle)*distance - center.size*(.05 + U.rand01()*.18),
          fall:center.size*(.42 + U.rand01()*.72),
          life:effect === 'burst' ? 1.65 + U.rand01()*.55 : 1.55 + U.rand01()*.55,
          delay:U.rand01()*.16
        });
      }
    }

    document.body.appendChild(root);
    window.setTimeout(function(){
      if(root && root.parentNode) root.parentNode.removeChild(root);
    }, effect === 'rain' ? 3800 : (effect === 'standard-swirl' ? 3400 : (effect === 'sparkles' ? 3300 : 3000)));
  }

  function runColorConfetti(){ runPremiumCelebration({ effect:'classic', intensity:'standard', colorMode:'wheel', mode:'standard' }); }
  function runImageConfetti(img){ runPremiumCelebration({ effect:'classic', intensity:'standard', colorMode:'wheel', mode:'logo', image:img }); }


  function runCreativeCelebration(canvas, img){
    var ui = TW.state && TW.state.ui ? TW.state.ui : {};
    var segs = TW.state.segments || [];
    var colors = segs.map(function(s){ return s.color; }).filter(Boolean);
    if(!colors.length) colors = TW.CONST.PALETTE.slice(0,6);
    var colorMode = String(ui.spinBizCelebrationColor || 'wheel');
    if(colorMode === 'winner' && TW.state._meta && TW.state._meta.lastWinnerIdx != null && segs[TW.state._meta.lastWinnerIdx] && segs[TW.state._meta.lastWinnerIdx].color){ colors = [segs[TW.state._meta.lastWinnerIdx].color]; }
    if(colorMode === 'custom'){
      var custom = String(ui.spinBizCelebrationCustomColor || 'ff4fa3').replace('#','');
      if(/^[0-9a-fA-F]{6}$/.test(custom)) colors = ['#' + custom];
    }
    var effect = String(ui.spinBizCelebrationEffect || 'classic');
    var intensity = String(ui.spinBizCelebrationIntensity || 'standard');
    var mode = String(ui.spinBizConfettiMode || 'standard');
    if(mode === 'emoji') mode = 'standard';
    var base = intensity === 'light' ? 150 : (intensity === 'huge' ? 650 : 360);
    // Safari/iOS pays heavily for hundreds of full-screen Retina canvas particles.
    // Keep the same effect and duration, but use a visually equivalent Apple particle budget.
    if(isIOS()) base = Math.max(72, Math.round(base * 0.44));
    if(img && mode === 'logo') base = Math.round(base * .52);
    var dur = intensity === 'light' ? 1900 : (intensity === 'huge' ? 3400 : 2600);

    canvas.hidden = false;
    var dpr = Math.max(1, Math.min(isIOS() ? 1.25 : 1.75, window.devicePixelRatio || 1));
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr,0,0,dpr,0,0);
    var W=window.innerWidth, H=window.innerHeight, parts=[];

    function makePart(i){
      var p={x:W/2,y:H*.2,vx:0,vy:0,g:.22+U.rand01()*.2,rot:U.rand01()*Math.PI*2,vr:(U.rand01()-.5)*.2,sz:5+U.rand01()*10,c:colors[(colors.length*U.rand01())|0],sparkle:false};
      if(effect==='rain'){
        p.x=U.rand01()*W; p.y=-20-U.rand01()*H*.35; p.vx=(U.rand01()-.5)*1.5; p.vy=2+U.rand01()*3; p.g=.025+U.rand01()*.035;
      }else if(effect==='cannons'){
        var left=i%2===0; p.x=left?-10:W+10; p.y=H*.88+U.rand01()*28; p.vx=(left?1:-1)*(5.5+U.rand01()*9.5); p.vy=-14-U.rand01()*10; p.g=.31+U.rand01()*.16;
      }else if(effect==='burst'){
        var a=U.rand01()*Math.PI*2, sp=5+U.rand01()*11; p.x=W/2; p.y=H*.42; p.vx=Math.cos(a)*sp; p.vy=Math.sin(a)*sp-2; p.g=.12+U.rand01()*.16;
      }else if(effect==='sparkles'){
        p.x=U.rand01()*W; p.y=U.rand01()*H; p.vx=(U.rand01()-.5)*1.0; p.vy=(U.rand01()-.5)*.7; p.g=0; p.sz=4+U.rand01()*10; p.sparkle=true;
      }else{
        p.x=W/2+(U.rand01()-.5)*130; p.y=H*.18+(U.rand01()-.5)*45; p.vx=(U.rand01()-.5)*12; p.vy=-6-U.rand01()*10; p.g=.34+U.rand01()*.22;
      }
      return p;
    }
    for(var i=0;i<base;i++) parts.push(makePart(i));
    var start=performance.now();
    var lastFrame=start;
    function frame(t){
      // Time-based movement keeps confetti moving at the intended speed even
      // when Safari drops frames. The old per-frame physics appeared to freeze
      // near the top because fewer frames also meant less movement.
      var step60 = Math.max(0.65, Math.min(3.0, (t - lastFrame) / 16.6667));
      lastFrame = t;
      ctx.clearRect(0,0,W,H); var alive=0;
      for(var j=0;j<parts.length;j++){
        var p=parts[j];
        p.vy += p.g * step60;
        p.x += p.vx * step60;
        p.y += p.vy * step60;
        p.rot += p.vr * step60;
        if(p.y<H+80 && p.y>-100 && p.x>-100 && p.x<W+100){
          alive++; ctx.save(); ctx.translate(p.x,p.y); ctx.rotate(p.rot);
          var remaining = Math.max(0, dur - (t - start));
          var endFade = effect === 'sparkles' ? Math.min(1, remaining / 850) : 1;
          ctx.globalAlpha=(effect==='sparkles' ? (.45+.5*Math.abs(Math.sin((t-start)/180+j))) * endFade : .94);
          var useImg=!!img && (mode==='logo' || (mode==='mixed' && j%4===0));
          if(useImg){ var iz=18+p.sz*2.1; ctx.drawImage(img,-iz/2,-iz/2,iz,iz); }
          else if(p.sparkle){
            ctx.fillStyle=p.c; ctx.beginPath(); ctx.moveTo(0,-p.sz); ctx.lineTo(p.sz*.24,-p.sz*.24); ctx.lineTo(p.sz,0); ctx.lineTo(p.sz*.24,p.sz*.24); ctx.lineTo(0,p.sz); ctx.lineTo(-p.sz*.24,p.sz*.24); ctx.lineTo(-p.sz,0); ctx.lineTo(-p.sz*.24,-p.sz*.24); ctx.closePath(); ctx.fill();
          }else{ ctx.fillStyle=p.c; ctx.fillRect(-p.sz/2,-p.sz/3,p.sz,p.sz*.66); }
          ctx.restore();
        }
      }
      if(t-start<dur && alive>0) requestAnimationFrame(frame); else { canvas.hidden=true; ctx.clearRect(0,0,W,H); }
    }
    requestAnimationFrame(frame);
  }

  function getWheelCenter(){
    try{
      if(!R.wheelWrap) return { x: window.innerWidth/2, y: window.innerHeight/2, size: 160 };
      var rect = R.wheelWrap.getBoundingClientRect();
      var size = Math.max(120, Math.min(210, rect.width * 0.30));
      return { x: rect.left + rect.width/2, y: rect.top + rect.height/2, size: size };
    }catch(_){
      return { x: window.innerWidth/2, y: window.innerHeight/2, size: 160 };
    }
  }

  function positionCountCard(card){
    if(!card) return;
    var c = getWheelCenter();
    card.style.left = c.x + 'px';
    card.style.top = c.y + 'px';
    card.style.width = c.size + 'px';
    card.style.height = c.size + 'px';
  }

  function runCountdown(sec, done){
    sec = U.clamp(sec|0, 1, 10);
    var overlay = R.countOverlay;
    if(!overlay) return done();

    overlay.innerHTML = '';

    var card = U.el('div', { class:'tw-countCard' });
    var num = U.el('div', { class:'tw-countNum', text:String(sec) });

    var ring = document.createElementNS('http://www.w3.org/2000/svg','svg');
    ring.setAttribute('class','tw-countRing');
    ring.setAttribute('viewBox','0 0 120 120');

    var cBack = document.createElementNS('http://www.w3.org/2000/svg','circle');
    cBack.setAttribute('cx','60'); cBack.setAttribute('cy','60'); cBack.setAttribute('r','52');
    cBack.setAttribute('fill','none');
    cBack.setAttribute('stroke','rgba(20,22,28,.12)');
    cBack.setAttribute('stroke-width','10');

    var cProg = document.createElementNS('http://www.w3.org/2000/svg','circle');
    cProg.setAttribute('cx','60'); cProg.setAttribute('cy','60'); cProg.setAttribute('r','52');
    cProg.setAttribute('fill','none');
    cProg.setAttribute('stroke','rgba(34,211,238,.88)');
    cProg.setAttribute('stroke-width','10');
    cProg.setAttribute('stroke-linecap','round');
    cProg.setAttribute('transform','rotate(-90 60 60)');

    var C = 2*Math.PI*52;
    cProg.setAttribute('stroke-dasharray', String(C));
    cProg.setAttribute('stroke-dashoffset', String(0));

    ring.appendChild(cBack);
    ring.appendChild(cProg);

    card.appendChild(ring);
    card.appendChild(num);

    overlay.appendChild(card);
    overlay.hidden = false;

    positionCountCard(card);

    var onMove = function(){ positionCountCard(card); };
    window.addEventListener('resize', onMove, { passive:true });
    window.addEventListener('scroll', onMove, { passive:true });

    var start = performance.now();
    var total = sec * 1000;

    function cleanup(){
      window.removeEventListener('resize', onMove);
      window.removeEventListener('scroll', onMove);
    }

    function tick(t){
      var elapsed = t - start;
      var leftMs = Math.max(0, total - elapsed);
      var left = Math.ceil(leftMs/1000);
      num.textContent = String(left);

      var p = U.clamp(elapsed / total, 0, 1);
      cProg.setAttribute('stroke-dashoffset', String(C * p));

      if(elapsed < total){
        requestAnimationFrame(tick);
      }else{
        cleanup();
        overlay.hidden = true;
        overlay.innerHTML = '';
        done();
      }
    }
    requestAnimationFrame(tick);
  }

  // --- recenter after spin ---
  TW.recenterWheel = function(animated){
    if(TW._rt.spinning) return;
    if(!R.wheelGroup) return;

    var cur = R.wheelRotateDeg || 0;
    var target = Math.round(cur / 360) * 360;

    if(!animated){
      setWheelDeg(target);
      clearSliceWin();
      return;
    }

    var start = performance.now();
    var dur = 320;
    var from = cur;
    var to = target;

    function easeOut(t){ return 1 - Math.pow(1-t, 3); }

    function frame(t){
      var p = U.clamp((t - start)/dur, 0, 1);
      var e = easeOut(p);
      setWheelDeg(from + (to-from)*e);
      if(p < 1) requestAnimationFrame(frame);
      else{
        setWheelDeg(to);
        clearSliceWin();
      }
    }
    requestAnimationFrame(frame);
  };

  // --- winner modal ---
  function openWinnerModal(idx){
    var segs = TW.state.segments || [];
    if(idx < 0 || idx >= segs.length) return;

    var s = segs[idx];
    TW.state._meta.lastWinnerIdx = idx;
    TW.track && TW.track('wheel_spin_complete', {
      plan: TW.access && TW.access.getUserPlan ? TW.access.getUserPlan() : 'free',
      segment_count: segs.length,
      spin_experience: String((TW.state.ui && TW.state.ui.spinExperience) || 'classic')
    });

    stopSpinSoundNow();

    runConfetti(shouldForceExperienceConfetti());

    // ✅ voice gated (defaults OFF; toggle controls it)
    var hasHiddenAnswer = !!(String(s.revealAnswer || '').trim() && String(s.revealClue || '').trim());
    if(!hasHiddenAnswer) TW.speakWinner && TW.speakWinner(s.resultLabel || s.label);

    var back = R.modalBack, modal = R.modal;
    if(!back || !modal) return;

    // Build the winner modal while hidden, then reveal it in one paint.
    // This avoids the first-spin blank/hesitation flash on slower browsers.

    var removed = false;
    function removeWinnerNow(){
      if(removed) return;
      var arr = TW.state.segments || [];
      var at = arr.indexOf(s);
      if(at < 0){
        var lbl = (s.label||'').toUpperCase();
        at = arr.findIndex(function(x){ return (x && (x.label||'').toUpperCase()) === lbl; });
      }
      if(at >= 0){
        TW.pushUndo();
        arr.splice(at, 1);
        removed = true;
        TW.renderAll && TW.renderAll();
        TW.saveSoon && TW.saveSoon();
      }
    }

    var didAdvanceMulti = false;

    function close(reason, opts){
      opts = opts || {};
      back.hidden = true;
      modal.hidden = true;
      modal.innerHTML = '';
      modal.classList.remove('isSpinBizPromo');
      modal.classList.remove('hasVortexContent');
      modal.classList.remove('tw-winnerModalActive');
      TW._positionWinnerModal = null;
      ['left','top','right','transform','max-height','animation','visibility'].forEach(function(prop){ modal.style.removeProperty(prop); });
      back.classList.remove('tw-bizSpotlightBack');
      back.style.removeProperty('background');
      back.style.removeProperty('-webkit-backdrop-filter');
      back.style.removeProperty('backdrop-filter');
      var spotlightShade = document.querySelector('.tw-bizSpotlightShade');
      if(spotlightShade && spotlightShade.parentNode) spotlightShade.parentNode.removeChild(spotlightShade);

      if(reason === 'x'){
        playReturnSound();
      }

      if((TW.state.ui.eliminateOn||'no') === 'yes'){
        removeWinnerNow();
      }

      setTimeout(function(){
        TW.recenterWheel && TW.recenterWheel(true);
      }, 40);

      if(reason !== 'spinAgain' && TW._rt && TW._rt.socialTrailPendingResult && TW.socialTrail && TW.socialTrail.openAfterSpinModal){
        var pendingTrailResult = TW._rt.socialTrailPendingResult;
        TW._rt.socialTrailPendingResult = null;
        setTimeout(function(){ TW.socialTrail.openAfterSpinModal(pendingTrailResult); }, 180);
      }

      if(TW._rt && TW._rt.multiActive && !opts.skipMulti && !didAdvanceMulti){
        didAdvanceMulti = true;
        setTimeout(function(){
          if(!TW._rt || !TW._rt.multiActive) return;
          if(TW._rt.spinning) return;
          if(!R.modalBack || !R.modalBack.hidden) return;

          if(TW._rt.multiRemaining > 0){
            TW._rt.multiRemaining--;
            if(!TW.state.segments || !TW.state.segments.length){
              TW._rt.multiRemaining = 0;
              TW._rt.multiActive = false;
              return;
            }
            TW.startSpin && TW.startSpin({ fromButton:true });
          }else{
            TW._rt.multiActive = false;
          }
        }, 350);
      }
    }

    back.onclick = function(){ close('backdrop'); };
    modal.classList.add('tw-winnerModalActive');
    function positionWinnerOverWheel(){
      if(!R.wheelWrap || !modal) return;
      var rect = R.wheelWrap.getBoundingClientRect();
      if(!rect || !rect.width || !rect.height) return;
      var vv = window.visualViewport;
      var viewLeft = vv ? vv.offsetLeft : 0;
      var viewTop = vv ? vv.offsetTop : 0;
      var viewWidth = vv ? vv.width : window.innerWidth;
      var viewHeight = vv ? vv.height : window.innerHeight;
      var margin = 12;
      var modalRect = modal.getBoundingClientRect();
      var modalWidth = modalRect.width || Math.min(520, Math.max(280, viewWidth - margin * 2));
      var modalHeight = modalRect.height || Math.min(780, Math.max(240, viewHeight - margin * 2));
      var halfWidth = Math.min(modalWidth / 2, Math.max(0, viewWidth / 2 - margin));
      var halfHeight = Math.min(modalHeight / 2, Math.max(0, viewHeight / 2 - margin));
      var targetX = rect.left + rect.width / 2;
      var targetY = rect.top + rect.height / 2;
      var minX = viewLeft + margin + halfWidth;
      var maxX = viewLeft + viewWidth - margin - halfWidth;
      var minY = viewTop + margin + halfHeight;
      var maxY = viewTop + viewHeight - margin - halfHeight;
      var left = minX <= maxX ? Math.max(minX, Math.min(maxX, targetX)) : viewLeft + viewWidth / 2;
      var top = minY <= maxY ? Math.max(minY, Math.min(maxY, targetY)) : viewTop + viewHeight / 2;
      modal.style.setProperty('left', left + 'px', 'important');
      modal.style.setProperty('top', top + 'px', 'important');
      modal.style.setProperty('right', 'auto', 'important');
      modal.style.setProperty('max-height', Math.max(220, viewHeight - margin * 2) + 'px', 'important');
      // Entrance keyframes temporarily own transform, then finish centered.
      modal.style.setProperty('transform', 'translate(-50%,-50%)');
    }
    TW._positionWinnerModal = positionWinnerOverWheel;
    if(!TW._winnerPositionResizeBound){
      TW._winnerPositionResizeBound = true;
      window.addEventListener('resize', function(){
        if(typeof TW._positionWinnerModal === 'function') TW._positionWinnerModal();
      }, { passive:true });
      window.addEventListener('scroll', function(){
        if(typeof TW._positionWinnerModal === 'function') TW._positionWinnerModal();
      }, { passive:true, capture:true });
      if(window.visualViewport){
        window.visualViewport.addEventListener('resize', function(){
          if(typeof TW._positionWinnerModal === 'function') TW._positionWinnerModal();
        }, { passive:true });
        window.visualViewport.addEventListener('scroll', function(){
          if(typeof TW._positionWinnerModal === 'function') TW._positionWinnerModal();
        }, { passive:true });
      }
    }
    requestAnimationFrame(positionWinnerOverWheel);
    setTimeout(positionWinnerOverWheel, 60);

    var top = U.el('div', { class:'tw-modalTop' }, [
      U.el('h3', { class:'tw-modalTitle', text:'Winner!' }),
      (function(){
        var x = U.el('button', { class:'tw-x', type:'button', 'aria-label':'Close' }, ['×']);
        x.onclick = function(){ close('x'); };
        return x;
      })()
    ]);

    var winnerTextColor = String((TW.state.ui && TW.state.ui.headerTextColor) || '').trim() || 'var(--tw-white)';
    var title = U.el('div', { class:'tw-vortexWinnerTitle', style:'font-weight:900; font-size:26px; line-height:1; text-align:center; padding:6px 0 10px 0; color:' + winnerTextColor + '; text-shadow:0 2px 10px rgba(0,0,0,.24);' }, [
      (hasHiddenAnswer ? 'MYSTERY RESULT' : (s.resultLabel || s.label || '')).toUpperCase()
    ]);
    var vortexDetail = null;
    var initialDetailText = hasHiddenAnswer ? String(s.revealClue || '') : String(s.fullText || '');
    if(initialDetailText && initialDetailText.trim().toLowerCase() !== String(s.label || '').trim().toLowerCase()){
      vortexDetail = U.el('div', {
        class:'tw-vortexWinnerDetail',
        style:'font-size:16px; line-height:1.45; text-align:center; padding:0 14px 12px; color:' + winnerTextColor + ';',
        text:initialDetailText
      });
    }
    var revealAnswerBtn = null;
    if(hasHiddenAnswer){
      revealAnswerBtn = U.el('button', { class:'tw-btn tw-btnPrimary tw-vortexRevealBtn', type:'button' }, ['Reveal Answer']);
      revealAnswerBtn.onclick = function(){
        title.textContent = String(s.revealAnswer || s.resultLabel || s.label || '').toUpperCase();
        if(vortexDetail) vortexDetail.textContent = String(s.fullText || s.resultLabel || '');
        revealAnswerBtn.hidden = true;
        TW.speakWinner && TW.speakWinner(s.revealAnswer || s.resultLabel || s.label);
      };
    }

    var bizPromo = null;
    var canUseSpinBiz = TW.access && TW.access.hasPlan ? TW.access.hasPlan('vortex_pro') : true;
    var bizUi = TW.state.ui || {};
    var rawBizUrl = String(bizUi.spinBizUrl || '').trim();
    var bizUrl = U.safeHttpUrl ? U.safeHttpUrl(rawBizUrl) : rawBizUrl;
    var bizPopupOn = canUseSpinBiz && String(bizUi.spinBizPopup || 'no') === 'yes';
    var bizPopupStyle = String(bizUi.spinBizPopupStyle || 'classic');
    var bizPopupEntrance = String(bizUi.spinBizPopupEntrance || 'pop');
    if(bizPopupOn){
      var mediaMode = String(bizUi.spinBizPopupMedia || 'none');
      var popImg = String(bizUi.spinBizPopupImage || '').trim();
      var mediaItems = [];
      if((mediaMode === 'image' || mediaMode === 'both') && popImg){
        mediaItems.push(U.el('div', { class:'tw-bizWinnerImageFrame' }, [ U.el('img', { class:'tw-bizWinnerImage', src:popImg, alt:'Winner promotion' }) ]));
      }
      if((mediaMode === 'qr' || mediaMode === 'both') && bizUrl){
        var qrFg = String(bizUi.spinBizQrFg || '2c0a71').replace('#','');
        var qrBg = String(bizUi.spinBizQrBg || 'ffffff').replace('#','');
        if(!/^[0-9a-fA-F]{6}$/.test(qrFg)) qrFg = '2c0a71';
        if(!/^[0-9a-fA-F]{6}$/.test(qrBg)) qrBg = 'ffffff';
        var qrLogo = String(bizUi.spinBizQrLogo || '').trim();
        var qrUrl = U.makeQrDataUrl ? U.makeQrDataUrl(bizUrl, qrFg, qrBg) : '';
        if(qrUrl){
          var qrFrame = U.el('div', { class:'tw-bizWinnerQrFrame' }, [ U.el('img', { class:'tw-bizWinnerQr', src:qrUrl, alt:'QR code' }) ]);
          if(qrLogo) qrFrame.appendChild(U.el('img', { class:'tw-bizWinnerQrLogo', src:qrLogo, alt:'Business logo' }));
          mediaItems.push(qrFrame);
        }
      }
      var promoChildren=[];
      var headline=String(bizUi.spinBizPopupHeadline == null ? 'Winner!' : bizUi.spinBizPopupHeadline).trim();
      var message=String(bizUi.spinBizPopupMessage || '').trim();
      if(headline) promoChildren.push(U.el('div',{class:'tw-bizWinnerHeadline',text:headline}));
      if(mediaItems.length) promoChildren.push(U.el('div',{class:'tw-bizWinnerMediaGrid'},mediaItems));
      if(message) promoChildren.push(U.el('div',{class:'tw-bizWinnerMessage',text:message}));
      var buttonText=String(bizUi.spinBizPopupButton == null ? 'Claim Prize' : bizUi.spinBizPopupButton).trim();
      if(buttonText && bizUrl){
        var claimBtn=U.el('button',{class:'tw-btn tw-btnPremium tw-bizClaimBtn',type:'button'},[buttonText]);
        claimBtn.onclick=function(){ window.open(bizUrl,'_blank','noopener'); };
        promoChildren.push(claimBtn);
      }
      bizPromo=U.el('div',{class:'tw-bizWinnerPromo'},promoChildren);
    }

    var elimNote = null;
    if((TW.state.ui.eliminateOn||'no') === 'yes'){
      elimNote = U.el('div', { class:'tw-mini', style:'text-align:center; margin-top:-4px;' }, [
        'Elimination is ON. This winner will be removed when you close or spin again (undo can restore).'
      ]);
    }

    var teamSel = U.el('select', { class:'tw-select' });
    teamSel.appendChild(U.el('option', { value:'', text:'Assign to team/player (optional)' }));
    (TW.state.teams||[]).forEach(function(t){
      teamSel.appendChild(U.el('option', { value:t.name, text:t.name }));
    });

    var pts = U.el('input', { class:'tw-input', type:'number', min:'0', step:'1', value:'0' });

    var row = U.el('div', { class:'tw-row tw-winnerAdvancedRow' }, [
      U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Assign team/player'}), teamSel ]),
      U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Points to add'}), pts ])
    ]);

    var btnPin = U.el('button', { class:'tw-btn', type:'button' }, ['Pin']);
    var btnRemove = U.el('button', { class:'tw-btn tw-btnDanger', type:'button' }, ['Remove winner']);
    var btnSpinAgain = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Spin again']);
    var btnChallenge = U.el('button', { class:'tw-btn tw-btnSecondary', type:'button' }, ['Send spin invite']);

    var actions = U.el('div', { class:'tw-toolbar tw-winnerPrimaryActions tw-winnerPrimaryActionsSimple', style:'justify-content:center; margin-top:12px;' }, (bizPopupOn ? [btnChallenge] : [
      btnSpinAgain, btnChallenge
    ]));

    var winnerCustomize = null;
    var customizationOfferDismissed = false;
    var effectsOfferDismissed = false;
    var quickTweaksVisited = !!(TW._rt && TW._rt.customizationEngaged);
    var winnerOfferSequenceDismissed = false;
    try{
      customizationOfferDismissed = sessionStorage.getItem('twDismissCustomizeOffer') === '1';
      effectsOfferDismissed = sessionStorage.getItem('twDismissEffectsOffer') === '1';
      quickTweaksVisited = quickTweaksVisited || sessionStorage.getItem('twQuickTweaksVisited') === '1';
      winnerOfferSequenceDismissed = sessionStorage.getItem('twDismissWinnerOfferSequence') === '1';
    }catch(_){ }
    var winnerUserPlan = TW.access && TW.access.getUserPlan ? TW.access.getUserPlan() : 'free';
    var winnerOverlayMode = !!(TW.state && TW.state.ui && (TW.state.ui.overlay || TW.state.ui.streamMode));
    var winnerActivationEligible = !winnerOverlayMode && winnerUserPlan !== 'vortex_pro';
    var customizationTourCompleted = false;
    try{ customizationTourCompleted = localStorage.getItem('tokiCustomizationTourV1') === 'completed'; }catch(_){}
    if(winnerActivationEligible && !winnerOfferSequenceDismissed && !customizationOfferDismissed){
      TW._rt = TW._rt || {};
      TW._rt.customizationPromptSpins = (TW._rt.customizationPromptSpins || 0) + 1;
      var winnerCustomizeButton = U.el('button', { class:'tw-startEditing tw-startEditingWinner', type:'button' }, [
        U.el('span', { class:'tw-startEditingIcon' }, [
          U.el('img', { src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/customizeicon.png?v=1786551564', alt:'', 'aria-hidden':'true' })
        ]),
        U.el('span', { class:'tw-startEditingCopy' }, [
          U.el('span', { class:'tw-startEditingKicker', text:customizationTourCompleted ? 'KEEP CREATING' : 'TRY YOUR OWN VERSION' }),
          U.el('strong', { text:customizationTourCompleted ? 'Customize even more' : 'Build a wheel that feels like yours' }),
          U.el('small', { text:customizationTourCompleted ? 'Update choices, colors, stickers, sounds, and wheel details anytime' : 'Take the quick tour and discover the customization tools' })
        ]),
        U.el('img', { class:'tw-startEditingArrow', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/mainwheelpanelsilverarrow.png?v=1789302960', alt:'', 'aria-hidden':'true' })
      ]);
      var dismissCustomize = U.el('button', { class:'tw-winnerOfferDismiss', type:'button', 'aria-label':'Hide customization suggestions for this session' }, ['×']);
      winnerCustomize = U.el('div', { class:'tw-winnerOfferWrap tw-winnerCustomizeOffer' }, [winnerCustomizeButton, dismissCustomize]);
      if(!TW._rt.customizationEngaged && TW._rt.customizationPromptSpins === 1){
        winnerCustomizeButton.classList.add('tw-activationFirstResult');
      }else if(!TW._rt.customizationEngaged && TW._rt.customizationPromptSpins === 2){
        winnerCustomizeButton.classList.add('tw-activationSecondSpin');
      }
      dismissCustomize.onclick = function(ev){
        ev.preventDefault(); ev.stopPropagation();
        try{ sessionStorage.setItem('twDismissCustomizeOffer','1'); }catch(_){ }
        try{ sessionStorage.setItem('twDismissWinnerOfferSequence','1'); }catch(_){ }
        if(TW.refs && TW.refs.btnStartEditing) TW.refs.btnStartEditing.hidden = true;
        winnerCustomize.remove();
      };
      winnerCustomizeButton.onclick = function(){
        TW.markCustomizationEngaged && TW.markCustomizationEngaged('winner_popup');
        close('customize', { skipMulti:true });
        var quickTweaks = document.getElementById('twOptions');
        if(quickTweaks){
          quickTweaks.open = true;
          try{ TW.track && TW.track('quick_tweaks_activation_click', { source:'winner_popup' }); }catch(_){}
          window.setTimeout(function(){ try{ quickTweaks.scrollIntoView({ behavior:'smooth', block:'start' }); }catch(_){} }, 60);
        }
      };
    }

    var spinUpsell = null;
    if(!winnerCustomize && !winnerOfferSequenceDismissed && !effectsOfferDismissed && quickTweaksVisited && !(TW.access && TW.access.hasPlan && TW.access.hasPlan('vortex_pro'))){
      var resultUpsellPlan = 'vortex_pro';
      var resultUpsellName = 'Vortex Pro';
      spinUpsell = U.el('div', { class:'tw-postSpinUpsell tw-postSpinEffectsOffer' }, [
        U.el('button', { class:'tw-winnerOfferDismiss tw-effectsOfferDismiss', type:'button', 'aria-label':'Hide spin effects suggestions for this session' }, ['×']),
        U.el('div', { class:'tw-postSpinEffectsCopy' }, [
          U.el('div', { class:'tw-postSpinEffectsKicker', text:'MAKE EVERY SPIN A MOMENT' }),
          U.el('div', { class:'tw-postSpinEffectsTitle', text:'Want crazier spin effects?' }),
          U.el('div', { class:'tw-postSpinUpsellText', text:'Unlock ' + resultUpsellName + ' for dramatic spin experiences and unforgettable winner reveals.' }),
          U.el('div', { class:'tw-postSpinEffectsPills' }, [
            U.el('span', { text:'Fakeouts' }),
            U.el('span', { text:'Blackout drops' }),
            U.el('span', { text:'Reactor surges' })
          ])
        ]),
        U.el('button', { class:'tw-btn tw-btnPremium tw-postSpinUpsellBtn', type:'button' }, ['Explore Spin Effects'])
      ]);
      spinUpsell.querySelector('.tw-effectsOfferDismiss').onclick = function(ev){
        ev.preventDefault(); ev.stopPropagation();
        try{ sessionStorage.setItem('twDismissEffectsOffer','1'); }catch(_){ }
        spinUpsell.remove();
      };
      spinUpsell.querySelector('.tw-postSpinUpsellBtn').onclick = function(){
        TW.openPlanUpsell && TW.openPlanUpsell(resultUpsellPlan, {
          kicker:'SPIN EFFECTS',
          title:'Premium spin experiences',
          message:'Unlock ' + resultUpsellName + ' for fakeouts, blackout drops, reactor surges, and customizable winner moments.',
          planSummary:resultUpsellName + ' unlocks dramatic spin effects and customizable winner experiences.',
          subtext:'Premium spin effects • custom winner moments • more ways to build suspense'
        });
      };
    }

    var advanced = U.el('details', { class:'tw-winnerToolDock', 'aria-label':'Winner tools' }, [
      U.el('summary', { class:'tw-winnerToolDockSummary' }, [
        U.el('span', { class:'tw-winnerToolDockIcon', 'aria-hidden':'true', text:'⋯' }),
        U.el('span', { class:'tw-winnerToolDockText', text:'More winner tools' })
      ]),
      U.el('div', { class:'tw-winnerToolDockBody' }, [
        U.el('div', { class:'tw-winnerToolTrayActions' }, [ btnPin, btnRemove ]),
        row
      ])
    ]);

    btnChallenge.onclick = function(){
      if(TW.openChallengeComposer){
        TW.openChallengeComposer({
          result: (s.resultLabel || s.label || '').toUpperCase(),
          wheelTitle: (TW.state && TW.state.ui && TW.state.ui.title) ? TW.state.ui.title : 'WHEEL'
        });
      }
    };

    /* After a free user completes the customization tour, make sharing the
       natural next discovery on their next winner. Pulse the real invite CTA,
       then open its existing composer once; never repeat in this browser. */
    try{
      var shareTourState = localStorage.getItem('tokiCustomizationTourShareV1') || '';
      var shareTourPlan = TW.access && TW.access.getUserPlan ? TW.access.getUserPlan() : 'free';
      if(shareTourState === 'pending' && shareTourPlan === 'free'){
        localStorage.setItem('tokiCustomizationTourShareV1','offered');
        btnChallenge.classList.add('tw-tourSharePulse');
        window.setTimeout(function(){
          try{
            btnChallenge.classList.remove('tw-tourSharePulse');
            var existing=document.querySelector('.tw-shareDiscoveryPrompt');
            if(existing)existing.remove();
            var prompt=document.createElement('section');
            prompt.className='tw-customTour tw-shareDiscoveryPrompt';
            prompt.setAttribute('role','dialog');
            prompt.setAttribute('aria-label','Send a spin invite');
            prompt.innerHTML='<button class="tw-tourClose" type="button" aria-label="Close sharing tip">&times;</button><div class="tw-tourKicker">PASS THE SPIN</div><div class="tw-tourHero"><div class="tw-tourHeroIcon"><img src="https://cdn.shopify.com/s/files/1/0709/3675/6398/files/tourspininviteicon.png?v=1789229255" alt="" aria-hidden="true"></div><div><strong class="tw-tourTitle">Send the fun to a friend</strong><p class="tw-tourText">One playful card. Your custom wheel. Their turn to spin.</p></div></div><div class="tw-shareDiscoveryPills"><span>Your wheel included</span><span>Easy to send</span><span>Ready to spin</span></div><button class="tw-btn tw-btnPrimary tw-shareDiscoveryAction" type="button">Show me the invite button</button>';
            document.body.appendChild(prompt);
            prompt.querySelector('.tw-tourClose').onclick=function(){prompt.remove();};
            prompt.querySelector('.tw-shareDiscoveryAction').onclick=function(){prompt.remove();btnChallenge.classList.add('tw-tourSharePulse');setTimeout(function(){btnChallenge.classList.remove('tw-tourSharePulse');},900);try{btnChallenge.focus({preventScroll:true});}catch(_){btnChallenge.focus();}};
            btnChallenge.addEventListener('click',function removeTip(){if(prompt.parentNode)prompt.remove();btnChallenge.removeEventListener('click',removeTip);});
          }catch(_){}
        }, 1450);
      }
    }catch(_){}


    btnRemove.onclick = function(){
      removeWinnerNow();
      close('removeBtn', { skipMulti:true });
    };

    btnPin.onclick = function(){
      TW.pushUndo();
      var team = teamSel.value || '';
      var p = parseInt(pts.value||'0',10);
      if(isNaN(p) || p < 0) p = 0;

      if(team){
        var t = (TW.state.teams||[]).find(function(x){ return x.name === team; });
        if(t){
          t.points = (t.points||0) + p;
        }
      }

      TW.state.pins = TW.state.pins || [];
      TW.state.pins.push({ label:(s.label||'').toUpperCase(), team: team || '', points: p, ts: U.nowLocalISO() });

      TW.state.history = TW.state.history || [];
      TW.state.history.push({ ts: U.nowLocalISO(), label:(s.label||'').toUpperCase(), team: team || '', points: p });

      TW.renderAll && TW.renderAll();
      TW.renderPins && TW.renderPins();
      TW.saveSoon && TW.saveSoon();
      if(TW.state && TW.state.ui && TW.state.ui.overlay){
        try{ TW.ensureOverlayVault && TW.ensureOverlayVault(); }catch(_){ }
        close('pin', { skipMulti:true });
      }
    };

    btnSpinAgain.onclick = function(){
      if((TW.state.ui.eliminateOn||'no') === 'yes'){
        removeWinnerNow();
      }

      if(TW._rt && TW._rt.multiActive){
        if(TW._rt.multiRemaining > 0){
          TW._rt.multiRemaining--;
        }else{
          TW._rt.multiActive = false;
        }
      }

      close('spinAgain', { skipMulti:true });
      TW.startSpin && TW.startSpin({ fromButton:true });
    };

    modal.innerHTML = '';
    modal.classList.toggle('hasVortexContent', !!(vortexDetail || hasHiddenAnswer));
    modal.classList.toggle('isSpinBizPromo', !!bizPopupOn);
    var spotlightOn = !!bizPopupOn && bizPopupStyle === 'spotlight';
    back.classList.toggle('tw-bizSpotlightBack', spotlightOn);
    if(spotlightOn){
      // Inline properties win over the many legacy Apple/WebKit cleanup rules.
      back.style.setProperty('background','rgba(7,4,18,.82)','important');
      back.style.setProperty('-webkit-backdrop-filter','blur(2px)','important');
      back.style.setProperty('backdrop-filter','blur(2px)','important');
      var oldSpotlightShade = document.querySelector('.tw-bizSpotlightShade');
      if(oldSpotlightShade && oldSpotlightShade.parentNode) oldSpotlightShade.parentNode.removeChild(oldSpotlightShade);
      var spotlightShade = document.createElement('div');
      spotlightShade.className = 'tw-bizSpotlightShade';
      spotlightShade.setAttribute('aria-hidden','true');
      document.body.appendChild(spotlightShade);
    }else{
      back.style.removeProperty('background');
      back.style.removeProperty('-webkit-backdrop-filter');
      back.style.removeProperty('backdrop-filter');
      var staleSpotlightShade = document.querySelector('.tw-bizSpotlightShade');
      if(staleSpotlightShade && staleSpotlightShade.parentNode) staleSpotlightShade.parentNode.removeChild(staleSpotlightShade);
    }
    ['classic','spotlight','prize','fullscreen'].forEach(function(k){ modal.classList.remove('tw-bizPopupStyle-' + k); });
    ['pop','zoom','drop','fade'].forEach(function(k){ modal.classList.remove('tw-bizPopupEntrance-' + k); });
    if(bizPopupOn){
      // Commit the removed animation class before re-adding it so repeated
      // winners replay the selected entrance instead of retaining its end state.
      void modal.offsetWidth;
      modal.classList.add('tw-bizPopupStyle-' + bizPopupStyle);
      modal.classList.add('tw-bizPopupEntrance-' + bizPopupEntrance);
    }
    modal.appendChild(top);
    modal.appendChild(title);
    if(vortexDetail) modal.appendChild(vortexDetail);
    if(revealAnswerBtn) modal.appendChild(revealAnswerBtn);
    if(bizPromo) modal.appendChild(bizPromo);
    if(elimNote) modal.appendChild(elimNote);
    modal.appendChild(actions);
    if(winnerCustomize) modal.appendChild(winnerCustomize);
    if(spinUpsell) modal.appendChild(spinUpsell);
    modal.appendChild(advanced);

    /* Never expose the browser's default modal position for a visible frame. */
    modal.style.setProperty('visibility', 'hidden', 'important');
    modal.style.setProperty('animation', 'none', 'important');
    back.hidden = false;
    modal.hidden = false;
    positionWinnerOverWheel();
    void modal.offsetWidth;
    modal.style.removeProperty('visibility');
    requestAnimationFrame(positionWinnerOverWheel);
    setTimeout(positionWinnerOverWheel, 80);
  }

  function computeTargetEndDeg(idx, extraTurns){
    var segs = TW.state.segments || [];
    var n = segs.length || 1;
    var step = 360 / n;

    var current = normDeg(R.wheelRotateDeg || 0);
    var target = normDeg(-idx * step);

    var delta = target - current;
    delta = normDeg(delta);

    var end = current + (extraTurns * 360) + delta;
    return end;
  }

  function spinToWinner(idx, opts){
    opts = opts || {};
    if(TW._rt.spinning) return;
    if(shouldUseSpinExperience()){
      runExperienceSpin(idx, opts);
      return;
    }

    if((TW.state.ui.centerBadgeEditOn||'no') === 'yes' && opts && opts.fromButton !== true){
      return;
    }

    var cfg = speedConfig();
    var dur = cfg.dur;
    var extraTurns = cfg.extraTurns;

    if(opts.flickPower != null){
      var p = U.clamp(opts.flickPower, 0, 1);
      extraTurns = Math.round(12 + p * 28);
    }

    var startNorm = normDeg(R.wheelRotateDeg || 0);
    // iOS: rotate via CSS transforms for smoother spinning
    TW._rt.useCssRotate = true; // All devices: composite the complete wheel SVG for smooth rotation
    setWheelDeg(startNorm);

    TW._rt.spinning = true;
    if(R.btnSpin) R.btnSpin.classList.remove('tw-spinIdlePulse');
    TW._rt.spinStart = performance.now();
    TW._rt.spinDur = dur;
    TW._rt.startDeg = startNorm;
    TW._rt.chosenIdx = idx;
    TW._rt.endDeg = computeTargetEndDeg(idx, extraTurns);

    playSpinSound(dur);

    if(R.wheelWrap) R.wheelWrap.classList.add('tw-spinning');

    function frame(t){
      var p = U.clamp((t - TW._rt.spinStart) / TW._rt.spinDur, 0, 1);
      var e = easeOutQuint(p);

      var jitter = 0;
      if(p > 0.85){
        var j = (p - 0.85)/0.15;
        jitter = Math.sin((t/18)) * (1-j) * 2.2;
      }

      var deg = TW._rt.startDeg + (TW._rt.endDeg - TW._rt.startDeg) * e + jitter;
      setWheelDeg(deg);

      // ✅ PERF (SURGICAL): During the main 5s spin we keep the wheel as a single rotating layer.
      // The heavier per-slice "alive" transforms are moved to the 3s pre-spin phase to reduce
      // work on Apple devices while spinning.

      if(p < 1){
        TW._rt.raf = requestAnimationFrame(frame);
      }else{
        setWheelDeg(TW._rt.endDeg);
        // Clear will-change after spin
        try{ if(R.wheelGroup) R.wheelGroup.style.willChange = ''; }catch(_){ }
        if(R.wheelWrap) R.wheelWrap.classList.remove('tw-spinning');

        clearSliceWin();
        setWinningSlice(idx);

        TW._rt.spinning = false;
        if(R.btnSpin) R.btnSpin.classList.add('tw-spinIdlePulse');

        stopSpinSoundNow();

        postSpinToCounter({
          winnerLabel: (TW.state.segments && TW.state.segments[idx] && TW.state.segments[idx].label) ? TW.state.segments[idx].label : ""
        });

        openWinnerModal(idx);
      }
    }

    TW._rt.raf = requestAnimationFrame(frame);
  }

  // =========================================================
  // ✅ SURGICAL: Pre-spin slice animation (moves the "rapid segment movement" here)
  // =========================================================
  function runPreSpinVisual(ms){
    ms = ms || 3000;
    try{ if(TW._rt && TW._rt.preSpinRAF){ cancelAnimationFrame(TW._rt.preSpinRAF); TW._rt.preSpinRAF = 0; } }catch(_){ }
    var t0 = performance.now();

    // Ensure we start clean (no winner pop or leftover transforms)
    try{ clearSliceWin(); }catch(_){ }

    function tick(t){
      var p = U.clamp((t - t0) / ms, 0, 1);
      // Animate individual slices (this is the effect you currently see during spin)
      try{ applySliceAlive(t, p); }catch(_){ }
      if(p < 1){
        TW._rt.preSpinRAF = requestAnimationFrame(tick);
      }else{
        // Reset transforms so the main spin starts from a "flattened" wheel
        try{ clearSliceWin(); }catch(_){ }
        TW._rt.preSpinRAF = 0;
      }
    }

    TW._rt = TW._rt || {};
    TW._rt.preSpinRAF = requestAnimationFrame(tick);
  }

  TW.startSpin = function(opts){
    opts = opts || {};
    if(TW._rt.spinning) return;
    if(!TW.state.segments || !TW.state.segments.length) return;
    if(R.modalBack && !R.modalBack.hidden) return;
    var usingSocialTrailPreview = false;
    var socialTrailSpinResult = null;
    if(TW.socialTrail && TW.socialTrail.activeTrail && TW.socialTrail.activeTrail()){
      socialTrailSpinResult = TW.socialTrail.consumeCurrentSpin ? TW.socialTrail.consumeCurrentSpin() : { ok:true };
      if(!socialTrailSpinResult.ok){
        TW.socialTrail.openLimitModal && TW.socialTrail.openLimitModal();
        TW.socialTrail.decorateButton && TW.socialTrail.decorateButton();
        return;
      }
      usingSocialTrailPreview = !!(socialTrailSpinResult && socialTrailSpinResult.index >= 0);
      TW.socialTrail.decorateButton && TW.socialTrail.decorateButton();
    }
    try{ if(TW.completeCustomizationTourFromSpin) TW.completeCustomizationTourFromSpin(); }catch(_){ }
    try{
      localStorage.setItem('tokiWheelHasSpunV1', 'yes');
      if(R.btnSpin) R.btnSpin.textContent = TW.i18n && TW.i18n.t ? TW.i18n.t('Spin') : 'Spin';
      document.dispatchEvent(new CustomEvent('toki:wheel-first-spin'));
    }catch(_){ }

    stopSpinSoundNow();

    function launchAfterPreSpin(){
      var idx = pickWeightedIndex();
      if(idx < 0) return;
      if(shouldUseSpinExperience()){
        clearSpinFx();
        runExperienceSpin(idx, opts);
      }else{
        spinToWinner(idx, opts);
      }
      TW.saveSoon && TW.saveSoon();
      if(usingSocialTrailPreview && socialTrailSpinResult && socialTrailSpinResult.remaining <= 0){
        TW._rt = TW._rt || {};
        TW._rt.socialTrailPendingResult = socialTrailSpinResult;
      }
      if(TW.socialTrail && TW.socialTrail.decorateButton){ TW.socialTrail.decorateButton(); }
    }

    function go(){
      // Keep the original startup hit for every mode, including experiences.
      if(R.wheelWrap) R.wheelWrap.classList.add('tw-prespining');

      try{ runPreSpinVisual(3000); }catch(_){ }
      try{ playPreSpinSound(); }catch(_){ }

      try{ if(TW._rt && TW._rt.preSpinTO){ clearTimeout(TW._rt.preSpinTO); TW._rt.preSpinTO = 0; } }catch(_){ }

      TW._rt = TW._rt || {};
      TW._rt.preSpinTO = setTimeout(function(){
        try{ if(R.wheelWrap) R.wheelWrap.classList.remove('tw-prespining'); }catch(_){ }
        try{ if(TW._rt && TW._rt.preSpinRAF){ cancelAnimationFrame(TW._rt.preSpinRAF); TW._rt.preSpinRAF = 0; } }catch(_){ }
        try{ clearSliceWin(); }catch(_){ }
        launchAfterPreSpin();
      }, 3000);
    }

    if(!shouldUseSpinExperience() && (TW.state.ui.countdownOn||'no') === 'yes'){
      runCountdown(TW.state.ui.countdownSec || 3, go);
    }else{
      go();
    }
  };

  function startMultiPick(){
    if(TW._rt.spinning) return;

    var max = (TW.state.segments||[]).length;
    if(max < 2){
      TW.startSpin({ fromButton:true });
      return;
    }

    var want = prompt('How many winners? (1–'+max+')', '3');
    if(want == null) return;

    var n = parseInt(want,10);
    if(!(n > 0)) n = 1;
    if(n > max) n = max;

    TW._rt.multiActive = (n > 1);
    TW._rt.multiRemaining = n - 1;

    TW.startSpin({ fromButton:true });
  }

  function bindSpinButtons(){
    if(!R.btnSpin) return;
    if(TW._spinButtonsBound) return;
    TW._spinButtonsBound = true;

    function activateSpinFromGesture(){
      TW._flickUnlockedBySpin = true;
      try{ if(R.hint) R.hint.textContent = ''; }catch(_){ }
      try{ TW.enableSoundAndVoiceFromGesture && TW.enableSoundAndVoiceFromGesture(); }catch(_){ }
      try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
      try{ TW.voiceBridge && TW.voiceBridge.arm && TW.voiceBridge.arm(); }catch(_){}
      if(TW._fidget && TW._fidget.on && TW.exitFidgetMode) TW.exitFidgetMode('spin');
      var spinOpts = { fromButton:true };
      try{
        if(TW._nextFlickPower != null){
          spinOpts.flickPower = TW._nextFlickPower;
          TW._nextFlickPower = null;
        }
      }catch(_){ }
      TW.startSpin(spinOpts);
    }
    /* One shared activation sequence for the real button and native wheel taps. */
    TW.activateSpinFromGesture = activateSpinFromGesture;
    R.btnSpin.addEventListener('click', activateSpinFromGesture);

    // ✅ GUARD: btnMulti can be missing on some templates/pages
    if(R.btnMulti && R.btnMulti.addEventListener){
      R.btnMulti.addEventListener('click', function(){
        TW._flickUnlockedBySpin = true;
        try{ if(R.hint) R.hint.textContent = ''; }catch(_){ }
        try{ TW.enableSoundAndVoiceFromGesture && TW.enableSoundAndVoiceFromGesture(); }catch(_){ }
        try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
        try{ TW.voiceBridge && TW.voiceBridge.arm && TW.voiceBridge.arm(); }catch(_){}
        if(TW._fidget && TW._fidget.on && TW.exitFidgetMode) TW.exitFidgetMode('spin');
        startMultiPick();
      });
    }

    // ✅ GUARD: btnUndo can be missing on some templates/pages
    if(R.btnUndo && R.btnUndo.addEventListener){
      R.btnUndo.addEventListener('click', function(){
        TW.undo && TW.undo();
      });
    }
  }

  function bindFlick(){
    if(!R.wheelWrap) return;
    if(TW._flickBound) return;
    TW._flickBound = true;

    var dragging = false;
    var cx = 0, cy = 0;
    var lastAng = 0;
    var lastT = 0;
    var vel = 0;
    var curDeg = 0;
    var touchGestureStarted = false;

    function posToAng(ev){
      var rect = R.wheelWrap.getBoundingClientRect();
      cx = rect.left + rect.width/2;
      cy = rect.top + rect.height/2;
      var x = ev.clientX - cx;
      var y = ev.clientY - cy;
      return Math.atan2(y, x);
    }

    R.wheelWrap.addEventListener('pointerdown', function(ev){
      if(!TW._flickUnlockedBySpin){
        try{ if(R.hint) R.hint.textContent = 'Press Spin once to enable flick-to-spin.'; }catch(_){ }
        return;
      }
      try{ TW.enableSoundAndVoiceFromGesture && TW.enableSoundAndVoiceFromGesture(); }catch(_){ }
      try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){ }
      try{ TW.primeWheelFxAudio && TW.primeWheelFxAudio(); }catch(_){ }
      try{ TW.voiceBridge && TW.voiceBridge.arm && TW.voiceBridge.arm(); }catch(_){ }

      if(TW._rt.spinning) return;
      if((TW.state.ui.centerBadgeEditOn||'no') === 'yes') return;
      if(TW._fidget && TW._fidget.on) return;

      dragging = true;
      R.wheelWrap.setPointerCapture(ev.pointerId);
      lastAng = posToAng(ev);
      lastT = performance.now();
      vel = 0;
      curDeg = R.wheelRotateDeg || 0;
    });

    // iOS speech synthesis is stricter than media playback on some releases:
    // a trusted touch event succeeds where the equivalent PointerEvent does not.
    // Keep this activation path separate from the pointer-based flick physics.
    R.wheelWrap.addEventListener('touchstart', function(){
      touchGestureStarted = true;
      if(!TW._flickUnlockedBySpin) return;
      try{ TW.enableSoundAndVoiceFromGesture && TW.enableSoundAndVoiceFromGesture(); }catch(_){ }
    }, { passive:true, capture:true });

    R.wheelWrap.addEventListener('touchend', function(){
      if(!touchGestureStarted) return;
      touchGestureStarted = false;
      if(!TW._flickUnlockedBySpin) return;
      try{ TW.enableSoundAndVoiceFromGesture && TW.enableSoundAndVoiceFromGesture(); }catch(_){ }
    }, { passive:true, capture:true });

    R.wheelWrap.addEventListener('touchcancel', function(){
      touchGestureStarted = false;
    }, { passive:true, capture:true });

    R.wheelWrap.addEventListener('pointermove', function(ev){
      if(!dragging || TW._rt.spinning) return;
      if(TW._fidget && TW._fidget.on) return;

      var a = posToAng(ev);
      var now = performance.now();
      var da = a - lastAng;
      if(da > Math.PI) da -= 2*Math.PI;
      if(da < -Math.PI) da += 2*Math.PI;

      var dt = Math.max(1, now - lastT);
      vel = da / dt;
      curDeg += (da * 180/Math.PI);
      setWheelDeg(curDeg);

      lastAng = a;
      lastT = now;
    });

    R.wheelWrap.addEventListener('pointerup', function(){
      if(!dragging || TW._rt.spinning) return;
      if(TW._fidget && TW._fidget.on) return;

      dragging = false;

      var power = U.clamp(Math.abs(vel) * 95, 0, 1);
      if(power < 0.12) return;

      // On Apple, complete speech activation on the qualifying pointerup too.
      // This mirrors the Spin button's final click activation instead of relying
      // only on the earlier pointerdown at the start of a potentially long drag.
      // Route flick completion through the exact Spin-button path that Apple
      // already accepts for sound and speech, while preserving flick velocity.
      try{ TW._nextFlickPower = power; }catch(_){ }
      if(R.btnSpin && typeof R.btnSpin.click === 'function'){
        R.btnSpin.click();
      }else{
        try{ TW._nextFlickPower = null; }catch(_){ }
        TW.startSpin({ flickPower:power, fromButton:true });
      }
    });

    R.wheelWrap.addEventListener('pointercancel', function(){
      dragging = false;
    });
  }

  // =========================================================
  // ✅ OVERLAY HOTKEYS (works even without Part5)
  // =========================================================
  function bindOverlayHotkeys(){
    if(TW._overlayHotkeysBound) return;
    TW._overlayHotkeysBound = true;

    function isTypingTarget(el){
      if(!el) return false;
      var tag = (el.tagName || '').toLowerCase();
      if(tag === 'input' || tag === 'textarea' || tag === 'select') return true;
      if(el.isContentEditable) return true;
      return false;
    }

    function modalIsOpen(){
      return !!(R.modalBack && !R.modalBack.hidden);
    }

    function clickModalButtonByText(txt){
      try{
        if(!R.modal) return false;
        var btns = R.modal.querySelectorAll('button');
        for(var i=0;i<btns.length;i++){
          var b = btns[i];
          if(!b) continue;
          var t = (b.textContent || '').trim().toLowerCase();
          if(t === txt.toLowerCase()){
            b.click();
            return true;
          }
        }
      }catch(_){}
      return false;
    }

    function closeModal(){
      try{
        if(R.modal){
          var x = R.modal.querySelector('.tw-modalTop .tw-x');
          if(x){ x.click(); return true; }
        }
      }catch(_){}
      try{
        if(R.modalBack && !R.modalBack.hidden){
          R.modalBack.click();
          return true;
        }
      }catch(_){}
      return false;
    }

    function tryEndOfRound(){
      try{
        if(typeof TW.endOfRoundWinner === 'function'){ TW.endOfRoundWinner(); return true; }
        if(typeof TW.pickEndRoundWinner === 'function'){ TW.pickEndRoundWinner(); return true; }
        if(typeof TW.endRound === 'function'){ TW.endRound(); return true; }
      }catch(_){}

      try{
        var sel = '#twEndRoundWin, #twEndRoundWinner, [data-tw-endround], .tw-endRoundBtn';
        var b = document.querySelector(sel);
        if(b){ b.click(); return true; }
      }catch(_){}

      return false;
    }

    window.addEventListener('keydown', function(ev){
      try{
        if(!TW.state || !TW.state.ui || !TW.state.ui.overlay) return;
        if(ev.defaultPrevented) return;
        if(ev.ctrlKey || ev.metaKey || ev.altKey) return;

        if(isTypingTarget(document.activeElement)) return;

        var key = ev.key;

        if(key === ' ' || key === 'Spacebar' || key === 'Enter'){
          if(modalIsOpen()) return;
          ev.preventDefault();
          if(TW._rt && TW._rt.spinning) return;

          try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
          try{ TW.voiceBridge && TW.voiceBridge.arm && TW.voiceBridge.arm(); }catch(_){}

          TW.startSpin && TW.startSpin({ fromButton:true });
          return;
        }

        if(key === 'Escape'){
          if(modalIsOpen()){
            ev.preventDefault();
            closeModal();
            return;
          }
          if(TW.state && TW.state.ui && TW.state.ui.overlay && TW.toggleOverlay){
            ev.preventDefault();
            TW.toggleOverlay();
          }
          return;
        }

        if(key === 'p' || key === 'P'){
          if(modalIsOpen()){
            ev.preventDefault();
            clickModalButtonByText('Pin');
          }
          return;
        }

        if(key === 'Backspace' || key === 'Delete'){
          if(modalIsOpen()){
            ev.preventDefault();
            clickModalButtonByText('Remove winner');
          }
          return;
        }

        if(key === 'e' || key === 'E'){
          ev.preventDefault();
          tryEndOfRound();
          return;
        }
      }catch(_){}
    }, { passive:false });
  }

  // =========================================================
  // ✅ FAIRNESS TESTER (10k runs)
  // =========================================================
  function runFairnessTest10k(){
    try{
      var prog = R.fairProg || document.getElementById('twFairProg');
      var out  = R.fairOut  || document.getElementById('twFairOut');

      R.fairProg = prog;
      R.fairOut  = out;

      if(prog) prog.textContent = 'Starting…';
      if(out) out.innerHTML = '';

      var segs = TW.state.segments || [];
      var n = segs.length;
      if(!n){
        if(prog) prog.textContent = 'No segments to test.';
        return;
      }

      var RUNS = 10000;
      var counts = new Array(n);
      for(var i=0;i<n;i++) counts[i] = 0;

      var wsum = 0;
      var weights = new Array(n);
      for(i=0;i<n;i++){
        var w = parseFloat(segs[i].weight);
        if(!(w > 0)) w = 1;
        weights[i] = w;
        wsum += w;
      }

      var done = 0;
      var chunk = 500;

      function step(){
        var end = Math.min(RUNS, done + chunk);
        for(var k=done;k<end;k++){
          var idx = pickWeightedIndex();
          if(idx >= 0) counts[idx]++;
        }
        done = end;

        if(prog){
          var pct = Math.floor((done/RUNS)*100);
          prog.textContent = 'Running… ' + pct + '%';
        }

        if(done < RUNS){
          setTimeout(step, 0);
        }else{
          if(prog) prog.textContent = 'Done: 10,000 spins';

          if(out){
            var sc = document.createElement('div');
            sc.style.maxWidth = '100%';
            sc.style.overflowX = 'auto';
            sc.style.overflowY = 'hidden';
            sc.style.webkitOverflowScrolling = 'touch';
            sc.style.borderRadius = '14px';

            var table = document.createElement('table');
            table.style.width = '100%';
            table.style.minWidth = '720px';
            table.style.borderCollapse = 'collapse';
            table.style.fontSize = '14px';
            table.style.whiteSpace = 'nowrap';
            table.style.tableLayout = 'fixed';

            var thead = document.createElement('thead');
            var hr = document.createElement('tr');

            ['Segment','Weight','Count','Expected %','Actual %','Δ (pp)'].forEach(function(h){
              var th = document.createElement('th');
              th.textContent = h;
              th.style.textAlign = 'left';
              th.style.padding = '8px 6px';
              th.style.borderBottom = '1px solid rgba(255,255,255,0.18)';
              hr.appendChild(th);
            });
            thead.appendChild(hr);
            table.appendChild(thead);

            var tbody = document.createElement('tbody');

            for(i=0;i<n;i++){
              var exp = (weights[i] / wsum) * 100;
              var act = (counts[i] / RUNS) * 100;
              var dpp = act - exp;

              var tr = document.createElement('tr');

              function td(txt, cls){
                var cell = document.createElement('td');
                cell.textContent = txt;
                if(cls) cell.className = cls;
                cell.style.padding = '8px 6px';
                cell.style.borderBottom = '1px solid rgba(255,255,255,0.10)';
                cell.style.overflow = 'hidden';
                cell.style.textOverflow = 'ellipsis';
                cell.style.whiteSpace = 'nowrap';
                return cell;
              }

              tr.appendChild(td((segs[i].label||'').toUpperCase(), 'twFairSegCell'));
              tr.appendChild(td(String(weights[i]), 'twFairWeightCell'));
              tr.appendChild(td(String(counts[i])));
              tr.appendChild(td(exp.toFixed(2) + '%'));
              tr.appendChild(td(act.toFixed(2) + '%'));
              tr.appendChild(td((dpp>=0?'+':'') + dpp.toFixed(2)));

              tbody.appendChild(tr);
            }

            table.appendChild(tbody);
            sc.appendChild(table);
            out.appendChild(sc);
          }
        }
      }

      step();
    }catch(e){
      try{
        var p2 = R.fairProg || document.getElementById('twFairProg');
        if(p2) p2.textContent = 'Error running tester.';
      }catch(_){}
    }
  }

  function bindFairnessPanel(){
    try{
      var btn = R.btnFairRun || document.getElementById('twFairRun');
      if(!btn) return;

      R.btnFairRun = btn;
      R.fairProg = R.fairProg || document.getElementById('twFairProg');
      R.fairOut  = R.fairOut  || document.getElementById('twFairOut');

      if(btn.__twFairBound) return;
      btn.__twFairBound = true;

      btn.addEventListener('click', function(){
        runFairnessTest10k();
      });
    }catch(_){}
  }

  // =========================================================
  // ✅ SURGICAL ADD: Overlay must ONLY show:
  // header + wheel card + pinned winners
  // =========================================================
  function enforceOverlayLayout(){
    try{
      var root = document.getElementById('toki-wheel-root');
      if(!root) return;

      var inOv = !!(TW.state && TW.state.ui && TW.state.ui.overlay);
      root.classList.toggle('tw-forceOverlayClean', inOv);

      if(inOv){
        var side = root.querySelector('.tw-vaultRebuilt');
        if(side){
          side.style.display = 'block';
          side.style.visibility = 'visible';
          side.style.opacity = '1';
        }

        var acc = root.querySelector('.tw-accord:not(.tw-vaultRebuilt)');
        if(acc){
          acc.style.display = 'none';
        }
      }else{
        var side2 = root.querySelector('.tw-vaultRebuilt');
        if(side2){
          side2.style.display = '';
          side2.style.visibility = '';
          side2.style.opacity = '';
        }
        var acc2 = root.querySelector('.tw-accord:not(.tw-vaultRebuilt)');
        if(acc2){
          acc2.style.display = '';
        }
      }
    }catch(_){}
  }

  // =========================================================
  // ✅ SURGICAL ADD: Voice Toggle in top panel
  // =========================================================
  function ensureVoiceDefaults(){
    try{
      // 2026-05-08J: Part5 owns the real session voice toggle.
      // Do NOT force TW.state.ui.voiceOn back to no here, because this
      // older Part4 helper was resetting the button state after the user
      // turned voice on and could make Windows look like it had no voice.
      TW.state.ui = TW.state.ui || {};
      if(TW.state.ui.voiceOn !== 'yes') TW.state.ui.voiceOn = 'no';
    }catch(_){}
  }

  function patchSpeakWinnerGate(){
    if(TW._voiceGatePatched) return;
    TW._voiceGatePatched = true;

    var orig = TW.speakWinner;
    if(typeof orig !== 'function') return;

    TW.speakWinner = function(text){
      try{
        TW.state.ui = TW.state.ui || {};
        if((TW.state.ui.voiceOn||'no') !== 'yes') return;
      }catch(_){}
      return orig.apply(this, arguments);
    };
  }

  function updateVoiceBtnUI(btn){
    try{
      ensureVoiceDefaults();
      var on = (TW.state.ui.voiceOn||'no') === 'yes';
      btn.textContent = TW.i18n && TW.i18n.t ? TW.i18n.t('Voice') : 'Voice';

      if(on){
        btn.classList.add('tw-btnPrimary');
      }else{
        btn.classList.remove('tw-btnPrimary');
      }
    }catch(_){}
  }

  function ensureVoiceToggleBtn(){
    try{
      ensureVoiceDefaults();
      patchSpeakWinnerGate();

      var root = document.getElementById('toki-wheel-root');
      if(!root) return;

      var header = root.querySelector('.tw-header');
      var actions = header && header.querySelector('.tw-actions');
      var existing = root.querySelector('#twVoiceToggle');
      if(existing){
        updateVoiceBtnUI(existing);
        return;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'twVoiceToggle';
      btn.className = 'tw-btn tw-btnIcon';
      btn.style.whiteSpace = 'nowrap';

      updateVoiceBtnUI(btn);

      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();

        // ✅ IMPORTANT: this click is a real user gesture on iOS.
        // Arm voice HERE so winner speech can work later after the spin finishes.
        try{ TW.voiceBridge && TW.voiceBridge.arm && TW.voiceBridge.arm(); }catch(_){}
        try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}

        TW.pushUndo && TW.pushUndo();
        ensureVoiceDefaults();
        var cur = (TW.state.ui.voiceOn||'no') === 'yes';
        TW.state.ui.voiceOn = cur ? 'no' : 'yes';
        updateVoiceBtnUI(btn);
        TW.saveSoon && TW.saveSoon();
      });

      if(actions) actions.appendChild(btn);
    }catch(_){}
  }

  // =========================================================
  // ✅ SURGICAL ADD: Fix image-picker popup going off-screen
  // + "Browse tagged images" button (tag=food test)
  // =========================================================
  var TW_TAG_BTN_LABEL = 'Browse tagged images'; // ✅ EDIT ME
  var TW_TAG_QUERY = 'tag:food';                 // ✅ TEST TAG: food

  function applyPopupScrollFix(container){
    try{
      if(!container) return;
      container.style.maxHeight = 'min(80vh, 720px)';
      container.style.overflow = 'auto';
      container.style.overscrollBehavior = 'contain';
      container.style.webkitOverflowScrolling = 'touch';
    }catch(_){}
  }

  function injectTaggedImagesButton(container){
    try{
      if(!container) return;

      if(container.__twTaggedBtnInjected) return;
      container.__twTaggedBtnInjected = true;

      // Prefer a real search input
      var inp =
        container.querySelector('input[type="search"]') ||
        container.querySelector('input[type="text"]');

      if(!inp) return;

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tw-btn tw-btnIcon';
      b.style.width = '100%';
      b.style.marginTop = '10px';
      b.textContent = TW_TAG_BTN_LABEL;

      b.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();

        try{
          inp.focus();
          inp.value = TW_TAG_QUERY;

          // Fire all common listeners
          inp.dispatchEvent(new Event('input', { bubbles:true }));
          inp.dispatchEvent(new Event('change', { bubbles:true }));

          // Some UIs only react on Enter
          inp.dispatchEvent(new KeyboardEvent('keydown', { bubbles:true, key:'Enter', code:'Enter' }));
          inp.dispatchEvent(new KeyboardEvent('keyup', { bubbles:true, key:'Enter', code:'Enter' }));
        }catch(_){}
      });

      var after = inp.parentElement;
      if(after && after.parentElement) {
        after.parentElement.insertBefore(b, after.nextSibling);
      } else {
        container.appendChild(b);
      }
    }catch(_){}
  }

  function watchPopups(){
    if(TW._popupWatchBound) return;
    TW._popupWatchBound = true;

    try{
      var root = document.getElementById('toki-wheel-root');
      if(!root) return;

      var scheduled = false;

      function runOnce(){
        if(scheduled) return;
        scheduled = true;
        requestAnimationFrame(function(){
          scheduled = false;
          try{
            enforceOverlayLayout();
            ensureVoiceToggleBtn();

            var modal = root.querySelector('.tw-modal');
            if(modal && !modal.hidden){
              applyPopupScrollFix(modal);
              injectTaggedImagesButton(modal);
            }

            var pop = root.querySelector('.tw-popover');
            if(pop){
              applyPopupScrollFix(pop);
              injectTaggedImagesButton(pop);
            }
          }catch(_){}
        });
      }

      var obs = new MutationObserver(function(){
        runOnce();
      });

      obs.observe(root, { childList:true, subtree:true });

      runOnce();
    }catch(_){}
  }

  // =========================================================
  // Bind
  // =========================================================
  TW.bindSpin = function(){
    bindSpinButtons();
    bindFlick();
    bindFairnessPanel();
    bindFidgetMode();
    bindOverlayHotkeys();

    // ✅ overlay/pinned/voice/popup fixes
    ensureVoiceDefaults();
    patchSpeakWinnerGate();
    enforceOverlayLayout();
    ensureVoiceToggleBtn();
    watchPopups();

    // ✅ NEW: arm voice/audio on first gesture inside the wheel root
    bindFirstGestureVoiceArm();
  };

  var tryBind = function(){
    try{ TW.socialTrail && TW.socialTrail.openIntroIfNeeded && TW.socialTrail.openIntroIfNeeded(); }catch(_){ }
    try{ TW.socialTrail && TW.socialTrail.decorateButton && TW.socialTrail.decorateButton(); }catch(_){ }

    if(R.btnSpin && R.wheelWrap){
      try{ ensureCenterBadge(); }catch(_){}
      TW.bindSpin();
    }else{
      setTimeout(tryBind, 60);
    }
  };
  tryBind();

})();
